export default {
  "common": {
      "view_more": "View more",
      "hide": "Hide",
      "view_less": "View less",
      "edit": "edit",
      "remove": "Remove",
      "delete": "Delete",
      "welcome_message": "Welcome to ELSA for Organizations",
      "slogan": "Speak English fluently, easily, and confidently",
      "invited_by": "Invited by",
      "agree_to": "I agree to the",
      "terms_and_conditions": "ELSA Terms and Conditions",
      "search": "Search",
      "email": "Email",
      "cancel": "Cancel",
      "save": "Save",
      "finish": "Finish",
      "done": "Done",
      "assign": "Assign",
      "or": "or",
      "ok": "OK",
      "none": "None",
      "account_confirmed": "Your account has been confirmed.",
      "no_values": "No values",
      "terms_and_privacy_policy": "Terms & Privacy Policy",
      "continue": "Continue",
      "invite": "Invite",
      "generic_error_message": "Something went wrong. Try again later.",
      "error_duplidate_group_name": "Duplicate class name in file",
      "login": "Login",
      "and": "&",
      "terms_of_use": "Terms of Use",
      "privacy_policy": "Privacy Policy",
      "name": "Name",
      "new": "New",
      "view_list": "View List",
      "total": "Total",
      "lesson": "Lesson",
      "lessons": "Lessons",
      "hours": "Hours",
      "hour": "Hour",
      "days": "Days",
      "day": "Day",
      "average": "Average",
      "lessons_per_day": "Lessons per Day",
      "minutes_per_day": "Minutes per Day",
      "pending_invites": "Pending Invites",
      "invite_success": "Invite was successfully accepted",
      "invite_not_success": "Invite could not be accepted",
      "invite_send_not_success": "Invite could not be resent",
      "no_invite_seleted": "There is no invite selected",
      "select_all": "Select all",
      "deselect_all": "Deselect all",
      "minutes": "Minutes",
      "warnings": {
          "no_report_data": "Could not fetch reports, try again",
          "session_expired": "You have been signed out due to inactivity. Please sign in to continue",
          "could_not_load_resource": "Could not load resource"
      },
      "resend_invite": "Resend invite",
      "remove_invite": "Remove Pending Invite",
      "export_report": "Export Report",
      "export_assessment": "Export Assessment",
      "lesson_detail": "Lesson Detail",
      "file_type_not_allowed": "File type is not allowed",
      "import": "Import",
      "assessment-history": "Assessment History",
      "remove_user_from_system_success": "Remove users from system successfully",
      "remove_user_from_system_warning": "Remove users from system unsucessfully",
      "add_role_to_user_success": "Assign role successfully",
      "add_role_to_user_warning": "Assign role unsuccessfully",
      "remove_user_from_system": "If check this box, you will delete these users from our system",
      "no_assessment_test_in_periods": "There are no assessment test in periods",
      "no_lessons_in_periods": "There are no lessons in periods",
      "items": "items",
      "item": "item",
      "data_selelected_info": "{selected} of {total} selected",
      "from_date_to_up_date": "{from_date} to {to_date}",
      "adding_duplicate_warning": "Oops, seems like you already have this item.",
      "not_allow_number_warning": "Oops, the item should not contain number.",
      "tag_input_max_length_warning": "An item can not be longer than {max_length} characters. Please edit this item.",
      "rename": "Rename",
      "add": "Add",
      "loading": "Loading",
      "choose_a_topic": "Choose a Topic",
      "filter": "Filter",
      "start_end_of_total": "{0} - {1} of {2}",
      "invite_teachers_title": "Invite {0}",
      "tag_input": {
          "click_here_to_view": "click here to view incorect spelling",
          "there_are_spelling_grammar": "There are spelling & grammar mistakes. Click on the",
          "text_icon_for_suggestions": "icon for suggestions or click on the item to edit.",
          "tag_input_max_length_warning": "An item can not exceed {max_length} characters.",
          "click_icon": "Click on the",
          "only_one_item_edit_same_time": "You have 1 item editing, please click icon check/cancel before edit other one.",
          "click_item_to_edit": "Click on the item to edit.",
          "item_length_over": "You have {character_limit} characters more than the limit.",
          "tag_input_cleanup_text_warning": "We will clean up the punctuation in your study sets.",
          "make_changes_to_the_cleaned_text": "to make changes to the cleaned-up text.",
          "cleaned_up_text": "Cleaned-up text"
      },
      "class_time_export_title": "{0} Report",
      "exporter_title": {
          "student_name": "Student Name",
          "student_email": "Student Email",
          "lessons_practiced": "Lessons Practiced",
          "studied_time": "Studied time",
          "average_daily_minutes_practiced": "Average Daily Minutes Practiced",
          "average_daily_lessons_practiced": "Average Daily Lessons Practiced",
          "duration_days": "Duration (days)",
          "first_eps": "First EPS",
          "last_eps": "Last EPS",
          "last_date_practiced": "Last Date Practiced",
          "last_assessment_score": "Last Assessment Score",
          "last_assessment_date": "Last Assessment Date",
          "score_improvement": "Score improvement",
          "eps_improvement": "Eps Improvement"
      },
      "copy_of": "Copy of ",
      "json_excel_download": "Download {0}",
      "elsa_dashboard": "Elsa Dashboard",
      "action": "Action",
      "got_it": "Got it",
      "confirm": "Confirm",
      "export_credentials": "Export Credentials",
      "copy_credential": "Copy Credential",
      "change_password": "Change Password",
      "dummy_email_credentials": "Login Alias Credentials",
      "update_name_success": "Update name successfully",
      "choose_a_skill": "Choose a Skill",
      "more": "more",
      "less": "less",
      "view": "View",
      "only": "only",
      "send": "Send",
      "confirm_title": "Are you sure?",
      "content_shareable": {
          "tooltip_shareable_to_this_org": "This Organization: Content is visible to all teachers and admins in your organization. It can be assigned to any class in your org. This content is not visible to external organizations. If your org structure includes branch organizations (“child” orgs), this content is not visible from any of the branch orgs.",
          "tooltip_shareable_to_branch": "This Organization + All Branches: Content is visible to all teachers and admins of this organization (the “parent” org). In addition, this content is visible to all of the parent organization’s branches (“child” orgs). The content is not visible to external organizations.",
          "tooltip_shareable_to_public": "All Organizations (Public): Content is visible to all ELSA organizations. It can be assigned by users from external organizations to learners outside of your org."
      },
      "due_by": "Due By",
      "error_message": {
        "used": "The assignment could not be created because study set <b>{studysetTitle}</b> has already been assigned to this {orgType}."
      },
      "last_login": "Last Login"
  },
  "date_interval_picker": {
      "start_end_date": "Start & End Date",
      "save": "Save",
      "cancel": "Cancel",
      "this_month": "This Month",
      "apply": "Apply"
  },
  "date_picker": {
      "start_date": "Start Date",
      "end_date": "End Date",
      "to": "To",
      "last_week": "Last week",
      "last_month": "Last month",
      "last_three_months": "Last 3 months",
      "last_six_months": "Last 6 months",
      "last_year": "Last year",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly"
  },
  "company_labels": {
      "average_lessons": "Number of days practiced per week",
      "all_users": "All learners",
      "groups": "Teams",
      "group": "Team",
      "teachers": "Team Leads",
      "remove_teacher_from_organization": "Remove lead from organization",
      "remove_student_from_organization": "Remove learner from organization",
      "update_teacher_from_organization": "Update lead of organization",
      "update_student_from_organization": "Update learner of organization",
      "remove_student_from_group": "Remove Learner from Team",
      "active_students": "Active Learners",
      "teacher": "Team lead",
      "students": "Learners",
      "student": "Learner",
      "all_groups": "All teams",
      "edit_group": "Edit Team",
      "select_group": "Select team",
      "add_to_group_title": "Add to Team",
      "remove_from_group_tilte": "Remove from Team",
      "remove_teacher": "Remove Leader from Team",
      "assign_teacher": "Assign Leader to Team",
      "add_to_group": "Add a New Team",
      "add_studyset_to_group": "Add a New Study Set",
      "import_class_success_title": "{numberClassesImported} Team[s] have been created successfully",
      "add_to_group_success": "Users have been added to team",
      "remove_from_group_success": "Users have been removed from team",
      "remove_from_class_success": "Users have been removed from team",
      "remove_from_class_warning": "Users could not be removed from team",
      "assign_license_to_user_success": "Assign license to user successfully",
      "assign_license_to_user_warning": "Assign license to user unsucessfully",
      "remove_from_organization_success": "Users have been removed from organization",
      "remove_from_organization_warning": "Users could not be removed from organization",
      "update_learner_of_organization_success": "Users have been updated successfully",
      "update_learner_of_organization_warning": "Users have been updated unsucessfully",
      "update_teacher_of_organization_success": "Users have been updated successfully",
      "update_teacher_of_organization_warning": "Users have been updated unsucessfully",
      "add_to_group_warning": "Users could not be added to team",
      "remove_from_group_warning": "Users could not be removed from team",
      "remove_teacher_from_group_success": "Teacher have been removed from team",
      "remove_teacher_from_group_warning": "Teacher could not be removed from team",
      "assign_teacher_to_group_success": "Leader have been assigned to team",
      "assign_teacher_to_group_warning": "Leader could not be assign to team",
      "class_has_not_teacher": "Team not assign leader",
      "class_has_teacher": "Team has assigned leader",
      "delete_group_success": "Delete teams successfully",
      "delete_group_warning": "Delete teams unsuccessfully",
      "confirm_remove_user_from_group": "Are you sure you want to remove this user from team ?",
      "confirm_remove_teacher_from_group": "Are you sure you want to remove this teacher from team ?",
      "create_new_group": "Create new team",
      "no_groups_yet": "You don’t have any teams yet.",
      "no_students_yet": "You don’t have any learners yet.",
      "create_group": "Create Team",
      "import_groups": "Import teams",
      "import_groups_success": "Teams have been created",
      "import_users_to_groups_success": "Import learners to teams success",
      "group_title": "Team title",
      "group_name": "Team name",
      "group_details": "Team details",
      "step_group_details": "Team details",
      "no_teachers_available": "No leads available",
      "no_group_available": "No team available",
      "all_teachers": "All leads",
      "all_students": "All Learners",
      "upload_emails": "Import learners to team",
      "errors": {
          "please_provide_group_name": "Please provide a team name",
          "please_provide_teacher_name": "Please provide a lead name",
          "please_select_team": "Please select team"
      },
      "add_students": "Add learners",
      "edit_student": "Edit learner",
      "edit_teacher": "Edit lead",
      "group_overview": "Team overview",
      "group_teacher": "Team Lead",
      "will_be_added_students": "{numberOfUsers} learners will be added to the class as soon as you create it.",
      "student_consent_to_class": "{numberOfUsers} learner(s) will be auto-enrolled in the team.",
      "students_list": "Learner List",
      "your_group_was_created": "Your team was created",
      "your_group_was_created_draft": "Your team was created to drafts",
      "error_when_inviting": "but there was an error when inviting learners. Try again later.",
      "invited_users": "and {students} learners were invited!",
      "goals": {
          "engage_students": "Set learning goals for the Team",
          "engage_review": "Encourage your learners to start practicing English. To start with, here are our suggestions:",
          "get_insight_about_students": "Get insight about your learners current pronunciation skills"
      },
      "invite_students": "Invite Learners",
      "student_name": "Learner Name",
      "teachers_page": {
          "title": "Team Leads",
          "invite": "Invite Leads",
          "table": {
              "number_of_students": "No. of learners",
              "number_of_classes": "No. of teams"
          }
      },
      "students_page": {
          "title": "Learners",
          "invite": "Invite Learners",
          "generate_dummy_learners": "Generate Learners with a Login Alias"
      },
      "curriculum_page": {
          "title": "Curriculum"
      },
      "select_teacher": "Select a team lead",
      "add_new_teacher": "Add a new team lead",
      "invite_new_teacher": "Invite New Team Lead",
      "invite_single_teacher": "Add Individual Team Lead",
      "invite_multiple_teachers": "Add Multiple Team Leads by Emails",
      "dashboard": {
          "class_overview": "Team overview",
          "view_class": "View Team",
          "profile": "Company Profile",
          "add_student": "Invite Learners",
          "new_group": "Create New Team",
          "add_teacher": "Invite Leads",
          "add_branch": "Add Branch"
      },
      "teacher_info": {
          "show_list_of_classes": "Show List of Teams",
          "show_list_of_students": "Show list of Learners",
          "classes_assigned_to": "Teams assigned to",
          "show_all_classes": "Show all teams"
      },
      "classes": {
          "active_students": "Active Learners (Practiced at Least one Lesson)",
          "import_users": "Import learners to multi-teams"
      },
      "students_improvement": "Team improvement",
      "empty_users_message_confirm": "You didn't add any learners, do you want to proceed ?",
      "auto_enroll_message_confirm": "Learner(s) will be auto-enrolled in the team. <br/>By choosing auto-enroll option, you must have prior permission from the learners to add them to this team. <br/>Do you want to continue?",
      "accept_invitation_enroll_message_confirm": "Learner(s) have to accept the invitation individually to enroll in the team. Do you want to continue?",
      "teacher_auto_enroll_message_confirm": "Team Lead(s) will be auto-enrolled in the team. <br/>By choosing auto-enroll option, you must have prior permission from the team leads to add them to this team. <br/>Do you want to continue?",
      "teacher_accept_invitation_enroll_message_confirm": "Team Lead(s) have to accept the invitation individually to enroll in the team. Do you want to continue?",
      "pending_invites_teacher": "Pending Invites Leader",
      "modals": {
          "delete": {
              "title": "Delete teams from organization",
              "message": "Are you sure you want to remove {numberOfClasses} team(s) from your organization?"
          },
          "invite_users": {
              "select_group_placeholder": "Select team",
              "assign_group": "Assign Team (optional)",
              "no_group_available": "No team available",
              "no_class_needed": "Invite only, no team needed",
              "assign_all": "Assign all to the team"
          },
          "delete_from_group": {
              "title": "Remove users from team",
              "message": "Are you sure you want to remove {numberOfAccounts} user(s) from your team?",
              "confirm": "Yes, Remove",
              "cancel": "No, Cancel"
          }
      },
      "create_group_flow": {
          "group_details": {
              "group_name_input_placeholder": "Enter your team name",
              "team_detail_tooltip": "Each team is required to have a name",
              "start_end_date": "Start & End Date"
          },
          "add_students": {
              "add_students_tooltip": "Enter learners to your class by entering their email addresses or importing the list of email addresses",
              "add_students_input_placeholder": "Click \"Enter\" after typing in each email address"
          },
          "group_created": {
              "goals_section": {
                  "assessment_test_desc": "Set the date when your team needs to complete the assessment."
              }
          }
      },
      "no_groups_desc": "Let’s start creating your first team and invite your learners to the team",
      "groups_desc": "Manage your teams, team leads, and your learners' access to ELSA",
      "get_set_up": {
          "title": "Get Set Up",
          "title_note": "Use this onboarding checklist to get started.",
          "step1": {
              "title": "Add Associate Admins",
              "description": "Start adding one or more associate admin(s) to your account. Admin(s) can create teams, set goals and reminders, invite learners and review reports. You can always add or remove an admin as needed.",
              "button": "Add Admins"
          },
          "step2": {
              "title": "Invite Team Leads",
              "description": "Invite Team Lead to manage your team.",
              "button": "Invite Team Leads"
          },
          "step3": {
              "title": "Create Teams",
              "description": "Creating teams, assign team leads, and set team goals.",
              "button": "Create Teams"
          },
          "step4": {
              "title": "Invite Learners",
              "description": "To invite learners to your team, manually add or upload their email addresses using the suggested form. Once invited, each learner will then be able to sign up for ELSA",
              "button": "Invite Learners"
          }
      },
      "charts": {
          "organization_performance": "Organization Performance",
          "distribution_by_learners_title": "Distribution of learners",
          "distribution_by_learners_desc": "Calculated based on ELSA’ score range.",
          "teamview_leaderboard_org_label": "Team view",
          "team_study_goal": "Team's study goal",
          "group": {
              "average_elsa_score_historical_progress_title": "Average Elsa Score Progress",
              "average_elsa_score_historical_progress_desc": "Changes in your team’s Average Elsa Score over time",
              "average_elsa_score_desc": "Based on results of learners in your team",
              "average_elsa_score_title": "Team’s average level",
              "learning_effort_decs": "Number of hours practiced vs. number of lessons practiced",
              "learning_effort_title": "Team Learning Efforts",
              "pentagon_title": "ELSA score breakdown by skills",
              "pentagon_desc": "Based on results of learners in your team",
              "ielts_title": "IELTS Speaking Score Distribution",
              "ielts_desc": "Predicted based on EPS score. This has not been approved or endorsed by IELTS or IDP.",
              "no_ielts_data_title": "Not enough data from your learners yet.",
              "no_ielts_data_desc": "Encourage your learners to take the assessment tests or practice more lessons to get speaking score predictors.",
              "performance_title": "Team Performance",
              "highest_average_score_skills_title": "Team's Accomplishments"
          },
          "organization": {
              "average_elsa_score_historical_progress_title": "Average Elsa Score Progress",
              "average_elsa_score_historical_progress_desc": "Changes in your organization’s Average Elsa Score over time",
              "average_elsa_score_desc": "Based on results of learners in your organization",
              "average_elsa_score_title": "Organization’s average level",
              "learning_effort_decs": "Number of hours practiced vs. number of lessons practiced",
              "learning_effort_title": "Organization Learning Efforts",
              "pentagon_title": "ELSA score breakdown by skills",
              "pentagon_desc": "Based on results of learners in your organization",
              "ielts_title": "IELTS Speaking Score Distribution",
              "ielts_desc": "Predicted based on EPS score. This has not been approved or endorsed by IELTS or IDP.",
              "no_ielts_data_title": "Not enough data from your learners yet.",
              "no_ielts_data_desc": "Encourage your learners to take the assessment tests or practice more lessons to get speaking score predictors.",
              "performance_title": "Organization Performance",
              "highest_average_score_skills_title": "Organization's Accomplishments"
          },
          "learner_col_label": "TEAM NAME",
          "tooltips": {
              "group_eps": "Up-to-dated average score computed from learners of the team for the selected period",
              "group_durations": "Total time practiced by the team over the selected period in HH:MM:SS format",
              "group_lessons_total": "Total number of lessons practiced by the team"
          }
      },
      "study_sets": {
          "organization": "This Organization",
          "group": "My Team(s) Only",
          "public": "All Organizations (Public)",
          "assign_to_group": "Assign to Team",
          "assign_to_groups": "Assigned to team",
          "assign_to_another_group": "Assign to Another Team",
          "recent_assigned_group": "Recent Assigned Team",
          "assigned_groups": "Assigned teams",
          "no_study_sets_desc": "Study Sets are your customized lessons that you can assign to your team.",
          "modals_delete_title": "Deleting selected study sets will affect your current teams. Continue?",
          "information_assignments_assigned_to": "Can’t find the team you are looking for? Type in the name of that team and press enter.",
          "information_study_set_shareable_to": "My Team Only: study set can only be viewed by your learners in the team to which you assign the study set. \nMy Organization: study set can be viewed by members of your organizations (i.e. admins and other leads). \nPublic: study set can be viewed by any ELSA users.",
          "branch": "This organization & its branches"
      },
      "assignments": {
          "modals_delete_title": "Are you sure you want to delete the selected assignment(s)?",
          "modals_delete_decs": "They will be deleted from your learners’ devices along with their progress.",
          "modals_delete_detail_title": "Are you sure you want to delete this assignment?",
          "modals_delete_detail_decs": "It will be deleted from your learners' devices\n along with their progress.",
          "no_assignments_yet": "There is no assignment in your team yet"
      },
      "homework_library": {
          "assigned_group": "Assigned Team"
      },
      "invite_teacher": {
          "firstname": "First name",
          "last_name": "Last Name",
          "email_validation_msg": "Please input correct email address"
      },
      "groups_col_label": "TEAMS",
      "groups_overview": "Team(s)",
      "teachers_overview": "Team Lead(s)",
      "branches": "Branches",
      "branches_overview": "Branch(es)",
      "remove_group": "Remove Team",
      "change_pass_dummy_email_success": "password was changed successfully!",
      "change_pass_dummy_email_warning": "password was changed unsuccessfully!",
      "content_shareable": {
          "tooltip_shareable_to_my_class": "My Team(s) Only: Content is visible to you and to your org’s admins. It is not visible to other teachers, unless they have admin status. This content can be assigned by you to any of your teams or by your org admins to another teacher’s team. It is not visible to external organizations."
      },
      "ai_role_plays": "AI Role-Plays"
  },
  "school_labels": {
      "average_lessons": "Number of days practiced per week",
      "all_users": "All learners",
      "groups": "Classes",
      "group": "Class",
      "teachers": "Teachers",
      "teacher": "Teacher",
      "students": "Learners",
      "student": "Learner",
      "active_students": "Active learners",
      "remove_teacher_from_organization": "Remove lead from organization",
      "remove_student_from_organization": "Remove learner from organization",
      "update_teacher_from_organization": "Update lead of organization",
      "update_student_from_organization": "Update learner of organization",
      "remove_student_from_group": "Remove Learner from Class",
      "all_teachers": "All teachers",
      "all_students": "All Learners",
      "all_groups": "All classes",
      "select_group": "Select class",
      "edit_group": "Edit Class",
      "add_to_group_title": "Add to Class",
      "remove_from_group_tilte": "Remove from Class",
      "remove_teacher": "Remove Teacher from Class",
      "assign_teacher": "Assign Teacher to Class",
      "add_to_group": "Add a New Class",
      "add_studyset_to_group": "Add a New Study Set",
      "import_class_success_title": "{numberClassesImported} classes have created successfully",
      "add_to_group_success": "Users have been added to class",
      "remove_from_group_success": "Users have been removed from class",
      "remove_from_organization_success": "Users have been removed from organization",
      "remove_from_organization_warning": "Users could not be removed from organization",
      "update_learner_of_organization_success": "Users have been updated successfully",
      "update_learner_of_organization_warning": "Users have been updated unsucessfully",
      "update_teacher_of_organization_success": "Users have been updated successfully",
      "update_teacher_of_organization_warning": "Users have been updated unsucessfully",
      "remove_from_class_success": "Users have been removed from team",
      "remove_from_class_warning": "Users could not be removed from team",
      "assign_license_to_user_success": "Assign license to user successfully",
      "assign_license_to_user_warning": "Assign license to user unsucessfully",
      "add_to_group_warning": "Users could not be added to class",
      "remove_from_group_warning": "Users could not be removed from class",
      "remove_teacher_from_group_success": "Teacher have been removed from class",
      "remove_teacher_from_group_warning": "Teacher could not be removed from class",
      "assign_teacher_to_group_success": "Teacher have been assigned to class",
      "assign_teacher_to_group_warning": "Teacher could not be assign to class",
      "class_has_not_teacher": "Class not assign teacher",
      "class_has_teacher": "Class has assigned teacher",
      "delete_group_success": "Delete classes successfully",
      "delete_group_warning": "Delete classes unsuccessfully",
      "confirm_remove_user_from_group": "Are you sure you want to remove this user from class ?",
      "confirm_remove_teacher_from_group": "Are you sure you want to remove this teacher from class ?",
      "create_new_group": "Create new class",
      "no_groups_yet": "There is no class in your organization yet",
      "no_students_yet": "You don’t have any learners yet.",
      "no_teachers_available": "No teachers available",
      "no_group_available": "No team available",
      "create_group": "Create class",
      "import_groups": "Import classes",
      "import_groups_success": "Classes have been created",
      "import_users_to_groups_success": "Import learners to classes success",
      "group_title": "Class title",
      "group_name": "Class Name",
      "group_details": "Class details",
      "step_group_details": "Class details",
      "select_teacher": "Select a teacher",
      "add_new_teacher": "Add new teacher",
      "invite_new_teacher": "INVITE NEW TEACHER",
      "invite_single_teacher": "Add Individual Teacher",
      "invite_multiple_teachers": "Add Multiple Teachers by Emails",
      "upload_emails": "Import learners to class",
      "errors": {
          "please_provide_group_name": "Please provide a class name",
          "please_provide_teacher_name": "Please provide a teacher name",
          "please_select_class": "Please select class"
      },
      "add_students": "Add learners",
      "edit_student": "Edit learner",
      "edit_teacher": "Edit teacher",
      "group_overview": "Class overview",
      "group_teacher": "Class Teacher",
      "will_be_added_students": "{numberOfUsers} Learners will be added to the class as soon as you create it.",
      "student_consent_to_class": "{numberOfUsers} learner(s) will be auto-enrolled in the class.",
      "students_list": "Learners List",
      "your_group_was_created": "Your class was created",
      "your_group_was_created_draft": "Your class was created to drafts",
      "error_when_inviting": "but there was an error when inviting learners. Try again later.",
      "invited_users": "and {students} Learners were invited!",
      "goals": {
          "engage_students": "Set learning goals for the Class",
          "engage_review": "You can ask your learners to start practicing English. Here’s what we suggest to start with:",
          "get_insight_about_students": "Get insight about your learners current pronunciation skills"
      },
      "invite_students": "Invite learners",
      "student_name": "Learner Name",
      "teachers_page": {
          "title": "Teachers",
          "invite": "Invite teachers",
          "table": {
              "number_of_students": "no. of learners",
              "number_of_classes": "no. of classes"
          }
      },
      "students_page": {
          "title": "Learners",
          "invite": "Invite learners",
          "generate_dummy_learners": "Generate Learners with a Login Alias"
      },
      "curriculum_page": {
          "title": "Curriculum",
          "create_new_studyset": "Create new study set",
          "no_studysets_yet": "There are no study set for now",
          "no_studysets_desc": "Study Sets are your customized lessons that you can assign to you class"
      },
      "dashboard": {
          "class_overview": "Class overview",
          "view_class": "View Class",
          "profile": "School Profile",
          "add_student": "Invite Learners",
          "new_group": "Create New Class",
          "add_teacher": "Invite Teachers",
          "add_branch": "Add Branch"
      },
      "teacher_info": {
          "show_list_of_classes": "Show List of Classes",
          "show_list_of_students": "Show list of Learners",
          "classes_assigned_to": "Classes assigned to",
          "show_all_classes": "Show all classes"
      },
      "classes": {
          "active_students": "Active Learners (Practiced at Least one Lesson)",
          "import_users": "Import learners to multi-classes"
      },
      "students_improvement": "Class improvement",
      "empty_users_message_confirm": "You didn't add any learners, do you want to proceed ?",
      "auto_enroll_message_confirm": "Learner(s) will be auto-enrolled in the class. <br/>By choosing auto-enroll option, you must have prior permission from the learners to add them to this class. <br/><br/>Do you want to continue?",
      "accept_invitation_enroll_message_confirm": "Learner(s) have to accept the invitation individually to enroll in the class. <br/>Do you want to continue?",
      "teacher_auto_enroll_message_confirm": "Teacher(s) will be auto-enrolled in the class. <br/>By choosing auto-enroll option, you must have prior permission from the teachers to add them to this class. <br/><br/>Do you want to continue?",
      "teacher_accept_invitation_enroll_message_confirm": "Teacher(s) have to accept the invitation individually to enroll in the class. <br/>Do you want to continue?",
      "pending_invites_teacher": "Pending Invites Teacher",
      "delete_user_from_class_message_confirm": "Are you sure you want to remove learner?",
      "modals": {
          "delete": {
              "title": "Delete classes from organization",
              "message": "Are you sure you want to remove {numberOfClasses} class(es) from your organization?"
          },
          "invite_users": {
              "select_group_placeholder": "Select class",
              "assign_group": "Assign Class (optional)",
              "no_group_available": "No class available",
              "no_class_needed": "Invite only, no class needed",
              "assign_all": "Assign all to the class"
          },
          "delete_from_group": {
              "title": "Remove users from class",
              "message": "Are you sure you want to remove {numberOfAccounts} user(s) from your class?",
              "confirm": "Yes, Remove",
              "cancel": "No, Cancel"
          }
      },
      "create_group_flow": {
          "group_details": {
              "group_name_input_placeholder": "Enter your class name",
              "team_detail_tooltip": "Each class is required to have a name",
              "start_end_date": "Start & End Date"
          },
          "add_students": {
              "add_students_tooltip": "Enter learners to your class by entering their email addresses or importing the list of email addresses",
              "add_students_input_placeholder": "Click \"Enter\" after typing in each email address"
          },
          "group_created": {
              "goals_section": {
                  "assessment_test_desc": "Set the date when your class needs to complete the assessment."
              }
          }
      },
      "no_groups_desc": "Let’s start creating your first class and invite your learners to the class",
      "groups_desc": "Manage your classes, teachers, and your learners' access to ELSA",
      "get_set_up": {
          "title": "Get Set Up",
          "title_note": "Use this onboarding checklist to get started.",
          "step1": {
              "title": "Add Associate Admins",
              "description": "Start adding one or more associate admin(s) to your account. Admin(s) can create teams, set goals and reminders, invite learners and review reports. You can always add or remove an admin as needed.",
              "button": "Add Admins"
          },
          "step2": {
              "title": "Invite Teachers",
              "description": "Invite Teacher to manage your team.",
              "button": "Invite Teachers"
          },
          "step3": {
              "title": "Create Classes",
              "description": "Creating Classes, assign teachers, and set class goals.",
              "button": "Create Classes"
          },
          "step4": {
              "title": "Invite Learners",
              "description": "To invite learners to your team, manually add or upload their email addresses using the suggested form. Once invited, each learner will then be able to sign up for ELSA",
              "button": "Invite Learners"
          }
      },
      "charts": {
          "organization_performance": "School Performance",
          "distribution_by_learners_title": "Distribution of learners",
          "distribution_by_learners_desc": "Calculated based on ELSA’ score range.",
          "teamview_leaderboard_org_label": "Class view",
          "team_study_goal": "Class's study goal",
          "group": {
              "average_elsa_score_historical_progress_title": "Average Elsa Score Progress",
              "average_elsa_score_historical_progress_desc": "Changes in your class’s Average Elsa Score over time",
              "average_elsa_score_desc": "Based on results of learners in your class",
              "average_elsa_score_title": "Class’s average level",
              "learning_effort_decs": "Number of hours practiced vs. number of lessons practiced",
              "learning_effort_title": "Class Learning Efforts",
              "pentagon_title": "ELSA score breakdown by skills",
              "pentagon_desc": "Based on results of learners in your class",
              "ielts_title": "IELTS Speaking Score Distribution",
              "ielts_desc": "Predicted based on EPS score. This has not been approved or endorsed by IELTS or IDP.",
              "no_ielts_data_title": "Not enough data from your learners yet.",
              "no_ielts_data_desc": "Encourage your learners to take the assessment tests or practice more lessons to get speaking score predictors.",
              "performance_title": "Class Performance",
              "highest_average_score_skills_title": "Class's Accomplishments"
          },
          "organization": {
              "average_elsa_score_historical_progress_title": "Average Elsa Score Progress",
              "average_elsa_score_historical_progress_desc": "Changes in your organization’s Average Elsa Score over time",
              "average_elsa_score_title": "School’s average level",
              "average_elsa_score_desc": "Based on results of learners in your school",
              "learning_effort_decs": "Number of hours practiced vs. number of lessons practiced",
              "learning_effort_title": "Organization Learning Efforts",
              "pentagon_title": "ELSA score breakdown by skills",
              "pentagon_desc": "Based on results of learners in your school",
              "ielts_title": "IELTS Speaking Score Distribution",
              "ielts_desc": "Predicted based on EPS score. This has not been approved or endorsed by IELTS or IDP.",
              "no_ielts_data_title": "Not enough data from your learners yet.",
              "no_ielts_data_desc": "Encourage your learners to take the assessment tests or practice more lessons to get speaking score predictors.",
              "performance_title": "Organization Performance",
              "highest_average_score_skills_title": "Organization's Accomplishments"
          },
          "learner_col_label": "CLASS NAME",
          "tooltips": {
              "group_eps": "Up-to-dated average score computed from learners of the class for the selected period",
              "group_durations": "Total time practiced by the class over the selected period in HH:MM:SS format",
              "group_lessons_total": "Total number of lessons practiced by the class"
          }
      },
      "study_sets": {
          "organization": "This Organization",
          "group": "My Class(es) Only",
          "public": "All Organizations (Public)",
          "assign_to_group": "Assign to Class",
          "assign_to_groups": "Assigned to class",
          "assign_to_another_group": "Assign to Another Class",
          "recent_assigned_group": "Recent assigned class",
          "assigned_groups": "Assigned classes",
          "no_study_sets_desc": "Study Sets are your customized lessons that you can assign to your class.",
          "modals_delete_title": "Deleting selected study sets will affect your current classes. Continue?",
          "information_assignments_assigned_to": "Can’t find the class you are looking for? Type in the name of that class and press enter.",
          "information_study_set_shareable_to": "My Class Only: study set can only be viewed by your learners in the class to which you assign the study set. \nMy Organization: study set ed by members of your organizations (e.g. admins and other teachers). \nPublic: study set can be viewed by any ELSA users.",
          "branch": "This organization & its branches"
      },
      "assignments": {
          "modals_delete_title": "Are you sure you want to delete the selected assignment(s)?",
          "modals_delete_decs": "They will be deleted from your learners’ devices along with their progress.",
          "modals_delete_detail_title": "Are you sure you want to delete this assignment?",
          "modals_delete_detail_decs": "It will be deleted from your learners' devices\n along with their progress.",
          "no_assignments_yet": "There is no assignment in your class yet"
      },
      "homework_library": {
          "assigned_group": "Assigned Class"
      },
      "groups_col_label": "CLASSES",
      "groups_overview": "Class(es)",
      "teachers_overview": "Teacher(s)",
      "branches": "Branches",
      "branches_overview": "Branch(es)",
      "remove_group": "Remove Class",
      "change_pass_dummy_email_success": "password was changed successfully!",
      "change_pass_dummy_email_warning": "password was changed unsuccessfully!",
      "content_shareable": {
          "tooltip_shareable_to_my_class": "My Class(es) Only: Content is visible to you and to your org’s admins. It is not visible to other teachers, unless they have admin status. This content can be assigned by you to any of your classes or by your org admins to another teacher’s class. It is not visible to external organizations."
      },
      "ai_role_plays": "AI Role-Plays (Demo)"
  },
  "elsa_goals": {
      "goals": "Use the top pronunciation app to help your learners improve their English skills:",
      "goal1": "Schedule flexible classes",
      "goal2": "See progress reports",
      "goal3": "Invite learners individually or as a group"
  },
  "navbar": {
      "dashboard": "Dashboard",
      "classes": "Classes",
      "teachers": "Teachers",
      "students": "Learners",
      "account": "Account",
      "my_profile": "My Profile",
      "manage": "Organization List",
      "logout": "Logout",
      "hello": "Hello",
      "organizations": "Organizations",
      "org_current": "Current Organization",
      "Language": "Language"
  },
  "teacher_info": {
      "profile": "Profile",
      "first_name": "First Name",
      "last_name": "Last Name",
      "email": "email",
      "username": "Username",
      "phone_number": "Phone Number",
      "user_roles": "User roles",
      "department": "Department",
      "title": "Title",
      "user_role": "User role",
      "overview": "Overview",
      "show_all_classes": "Show All classes"
  },
  "student_info": {
      "overview": "Overview",
      "profile": "Profile"
  },
  "user_profile": {
      "dont_belong_organization": "You don’t belong to any organizations.",
      "join_organization": "Join Organization",
      "create_organization": "Create Organization",
      "withdraw_from_organization": "Withdraw from organization",
      "your_profile": {
          "title": "your profile",
          "first_name": "First name",
          "last_name": "Last Name",
          "user_name": "Username",
          "email": "Email",
          "not_verified": "Not verified",
          "phone_number": "Phone number",
          "did_not_receive": "Didn’t receive the confirmation email?",
          "resent_email": "Resend Email",
          "modals": {
              "edit_profile": {
                  "update_success": "User has been successfully updated.",
                  "update_warning": "User has not successfully updated.",
                  "title": "Edit profile",
                  "upload_image": {
                      "label": "Upload image"
                  },
                  "first_name": {
                      "label": "First name",
                      "placeholder": "Enter your first name",
                      "validation_msg": "Please input first name"
                  },
                  "last_name": {
                      "label": "Last name",
                      "placeholder": "Enter your last name",
                      "validation_msg": "Please input last name"
                  },
                  "email": {
                      "label": "Email",
                      "placeholder": "Enter your email address",
                      "validation_msg": "Please input correct email address"
                  },
                  "user_name": {
                      "label": "Username",
                      "placeholder": "Enter your username"
                  },
                  "phone": {
                      "label": "Phone number",
                      "placeholder": "+1-000-000-0000",
                      "code_placeholder": "Code"
                  },
                  "save": "save",
                  "cancel": "cancel"
              },
              "confirm_new_email": {
                  "title": "Confirm your new email address",
                  "message": "We’ve sent you a confirmation email. Check your inbox and verify your new email address.",
                  "button_label": "Got it!"
              }
          }
      },
      "change_password": {
          "title": "change password",
          "password": "password",
          "modals": {
              "title": "Update your password",
              "current_password": {
                  "label": "Current password",
                  "placeholder": "Enter current password"
              },
              "new_password": {
                  "label": "New password",
                  "placeholder": "Enter 8 characters or more"
              },
              "confirm_new_password": {
                  "label": "Confirm new password",
                  "placeholder": "Enter 8 characters or more"
              },
              "save": "save",
              "cancel": "cancel",
              "change_pass_elsa": "Please use ELSA app to change your password.",
              "help_text": "We recommend setting a new password for your account for easier access to the Portal.",
              "button_text": "Update my password",
              "password_validation": {
                  "long": "must be at least 8 characters long.",
                  "lowercase": "must contain 1 lowercase letter.",
                  "uppercase": "must contain 1 uppercase letter.",
                  "number": "must contain 1 number.",
                  "repwd": "Please correct your password",
                  "correctpwd": "Please correct your password",
                  "match": "The confirm password must match password.",
                  "please_input": "Please input password",
                  "input_confirm": "Please input confirm password.",
                  "number_or_special_char": "must contain 1 number or 1 special character @!\"#$%&'()*+,-./:;<=>?"
              }
          },
          "message": "Your password has been updated successfully"
      },
      "your_organizations": {
          "title": "your organizations",
          "modals": {
              "title": "withdraw from {name}",
              "admin": {
                  "message_1": "Are you sure you want to withdraw from {name}?",
                  "message_2": "You are the only admin for {name}. In order to withdraw from the organization, invite someone else to be the account owner."
              },
              "teacher": {
                  "message_1": "Are you sure you want to withdraw from {name}? You will lose access to your current pro license.",
                  "message_2": "You are the assigned teacher for {numberOfClasses} classes. In order to withdraw from the organization, contact your organization admin to remove you from that role."
              },
              "student": {
                  "message_1": "If you withdraw, you’ll need a new invitation to join {name} again.",
                  "message_2": "Are you sure you want to withdraw from {name}? You will lose access to your current pro license."
              },
              "confirm": "yes, withdraw",
              "cancel": "no, cancel",
              "got_it": "got it!"
          }
      },
      "social": {
          "title": "social",
          "modals": {
              "title": "Enter password",
              "subtitle": "Enter a password so you can still access your ELSA account without Facebook",
              "password": {
                  "label": "New password",
                  "placeholder": "Enter new password",
                  "validation_msg": "Insert a password",
                  "not_match": "Two inputs don\\'t match!"
              },
              "repeat_password": {
                  "label": "Repeat new password",
                  "placeholder": "Repeat new password"
              },
              "save": "save",
              "cancel": "cancel"
          }
      },
      "delete_account": {
          "button": "delete account",
          "modals": {
              "title": "delete account",
              "warning": "Are you sure you want to withdraw from {organizationName}? If so, fill in the following:",
              "terms_and_conditions": "I understand I will lose access to my history data and to my current license.",
              "password": "Password",
              "delete_account": "delete account",
              "cancel": "cancel",
              "terms_validation_msg": "Please accept the delete conditions",
              "password_validation_msg": "Please input password"
          }
      }
  },
  "login": {
      "title": "Welcome to ELSA's Partner Portal",
      "accept_invitation": "Log in to your ELSA account to accept the invitation from {organizationName}.",
      "email_field": {
          "label": "email",
          "placeholder": "Enter email address",
          "validation_msg": "Please input correct email address",
          "validation_msg_1": "Please input email",
          "callback_msg": "Please input email"
      },
      "password_field": {
          "label": "password",
          "placeholder": "Enter your password",
          "validation_msg": "Please input password"
      },
      "forgot_password": "Forgot password?",
      "login_and_accept_invitation": "Log in and accept invitation",
      "dont_have_account": "Don't have an account?",
      "create_account": "Sign up",
      "login": "Sign in",
      "first_login": "Log in",
      "invalid_token": "Invitation token is expired or invalid",
      "pic_title": "Use the top pronunciation app to help your learners improve their English skills",
      "pic_text": "Schedule flexible classes • See progress reports • Invite learners individually or as a group",
      "title_note": "Use your ELSA partner login",
      "payment_first_login_msg": "Login to your admin account using the password provided in the purchase confirmation email.",
      "sso": {
          "title": "Login With SSO",
          "description": "Enter your work email",
          "email": "Email",
          "email_placeholder": "Enter your email",
          "email_validation_msg": "Please input correct email address",
          "app_id_invalid_data_request": "Invalid data request",
          "email_not_associated_sso": "Your email is not associated with a SSO account",
          "email_not_invited_to_your_organization": "Your email is not invited to access your organization's learning space",
          "failed_to_login_please_try_again_or_contact_support": "Failed to login. Please try again or contact support",
          "your_account_id_has_changed_please_contact_your_administrator_for_assistance": "Your account ID has changed. Please contact your administrator for assistance",
      },
      "001": {
        "001": {
            "006": "Email {email} is already registered. Please click Login With SSO or use a different account."
        }
      }
  },
  "confirm_account": {
      "title": "Confirm Your Account",
      "check_inbox": "We’ve sent you a confirmation email. Check your inbox and verify your account.",
      "didnt_receive": "Didn’t receive it?",
      "resend_confirmation": "Resend confirmation email",
      "got_it": "Got it!"
  },
  "resend_confirmation": {
      "title": "Resend Confirmation Email",
      "send_confirmation": "We’ll send you a new confirmation email. Please verify that your email address is correct.",
      "email_field": {
          "label": "email",
          "placeholder": "Enter email",
          "format_validation_msg": "Please input correct email address",
          "validation_msg": "Please input email"
      },
      "resend_email": "Resend Email"
  },
  "recover_password": {
      "title": "Forgot password",
      "enter_email_to_reset": "Fill in your email and we’ll send you a link to reset your password",
      "reset_pass_elsa": "Please use ELSA app to reset your password.",
      "email_field": {
          "label": "email address",
          "placeholder": "Enter email address"
      },
      "reset_password": "Reset Password",
      "sent_email_check_inbox": "If your account exists, you will receive an email with a link to reset your password.",
      "got_it": "Got it!",
      "please_input_email": "Please input email",
      "input_correct_email": "Please input correct email address"
  },
  "reset_password_modal": {
      "title": "Update your password",
      "enter_your_password": "New password",
      "button_text": "Update my password",
      "new_password_field": {
          "label": "New password",
          "placeholder": "Enter 8 characters or more"
      },
      "confirm_password_field": {
          "label": "Confirm new password",
          "placeholder": "Enter 8 characters or more"
      },
      "desc": "We recommend setting a new password for your admin access to the Portal."
  },
  "sign_up": {
      "title": "Create an Account",
      "sign_up": "Create your account",
      "first_name_field": {
          "label": "First Name",
          "placeholder": "Your first name?",
          "validation_msg": "Please insert first name"
      },
      "last_name_field": {
          "label": "Last Name",
          "placeholder": "Your last name?",
          "validation_msg": "Please insert last name"
      },
      "email_field": {
          "label": "Email",
          "placeholder": "you@example.com",
          "validation_msg": "Please input email",
          "correct_validation_msg": "Please input correct email address"
      },
      "password_field": {
          "label": "Password",
          "placeholder": "Enter your password",
          "validations": {
              "long": "must be at least 8 characters long.",
              "lowercase": "must contain 1 lowercase letter.",
              "uppercase": "must contain 1 uppercase letter.",
              "number": "must contain 1 number.",
              "correct_newpwd": "Please correct your password",
              "pwd_match": "The confirm password must match password.",
              "input_confirm_pwd": "Please input confirm password.",
              "input_pwd": "Please input password",
              "number_or_special_char": "must contain 1 number or 1 special character @!\"#$%&'()*+,-./:;<=>?"
          }
      },
      "confirm_password_field": {
          "label": "confirm password",
          "placeholder": "Enter your confirm password"
      },
      "company_name_field": {
          "label": "Company Name",
          "placeholder": "Enter your company name",
          "validation_msg": "Please insert company name"
      },
      "company_type_field": {
          "label": "Company Type",
          "placeholder": "Enter your company type",
          "validation_msg": "Please insert company name"
      },
      "signup_accept_invitation": "Sign up and Accept Invitation",
      "invitation_code": "Do you have an invitation code?",
      "tooltip_message": "If you have an invitation code, enter it here.",
      "by_signing_up_to_elsa": "By signing up for ELSA, you agree to our ",
      "already_have_an_account": "Already have an account?",
      "code_is_not_complete": "Code is not complete",
      "company_type": {
          "education": "Education",
          "non_education": "Non-Education"
      }
  },
  "verify_facebook_info_modal": {
      "title": "verify your info",
      "save_continue": "Save and continue",
      "first_name_field": {
          "label": "First name",
          "placeholder": "First name"
      },
      "last_name_field": {
          "label": "Last name",
          "placeholder": "Last name"
      },
      "email_field": {
          "label": "Email address",
          "placeholder": "Enter email address",
          "validation_msg": "Please input correct email address"
      }
  },
  "organizations": {
      "groups": "Groups",
      "users": "Users",
      "table": {
          "user_email": "Email address",
          "username": "Name",
          "titleDept": "title / dept.",
          "roles": "Role",
          "actions": "actions",
          "empty": "No user was found",
          "empty_admin": "No admins found",
          "empty_student": "No learners found",
          "empty_teacher": "No teachers found",
          "role": {
              "default_admin": "Default Admin",
              "associate_admin": "Associate Admin"
          }
      },
      "users_section": {
          "invite_users": "Invite users",
          "invite_by_email": "Invite by email",
          "import_users": "Import users to multi-groups",
          "import_elsa_id": "Import Elsa_Id to multi-groups",
          "share_code": "Get a code",
          "share_link": "Share a link",
          "share_qr_code": "Share QR code",
          "add_to_group": "Add to group",
          "add_to_class": "Add to class",
          "revoke_license": "Revoke license",
          "enable_license": "Enable license",
          "disable": "Disable",
          "delete": "Delete",
          "no_users": "Invite users to join your company:",
          "no_users_1": "You don’t have any users yet.",
          "no_users_2": "Add users or share your organization with them.",
          "select_role": "Select role",
          "user_profile": {
              "user_details": {
                  "title": "User details"
              },
              "user_roles": {
                  "title": "User role"
              }
          },
          "enable_license_message": "Pro License issued to {firstName} {lastName}",
          "modals": {
              "share_qr_code": {
                  "title": "share QR code",
                  "print_code": "Print the following QR code",
                  "share_with_users": "Share it with users so they can scan it to join your organization.",
                  "print": "Print",
                  "no_cancel": "Cancel"
              },
              "share_link": {
                  "title": "share a link",
                  "copy_link": "Copy link",
                  "got_it": "Got it!",
                  "cancel": "Cancel",
                  "title_text": "Share Link",
                  "link_copied": "Link copied to clipboard"
              },
              "share_code": {
                  "title": "Get a code",
                  "share_the_following_code": "Generate a code",
                  "user_can_join": "Share the code with users so they can use it to join your organization.",
                  "generate_code": "Generate code",
                  "done": "Done"
              },
              "invite_users": {
                  "copy_and_paste": "Copy and paste email addresses",
                  "title": "Invite Learners",
                  "title_single": "Invite Learner",
                  "add_learner": "Add learner",
                  "select_team_placeholder": "Select team",
                  "select_role_label": "User(s) role  ",
                  "copy_paste_emails": "Copy and paste email addresses",
                  "invite_users": "Invite Users",
                  "add_email": "Insert multiple email addresses (separated by commas)",
                  "success": "The users have been added to the user list",
                  "consent": "Consent",
                  "consent1": "Auto-enroll user(s) to the {organizationName}",
                  "assign_team": "Assign Team (optional)",
                  "assign_elsa_access": "Assign ELSA Access",
                  "select_role_placeholder": " ",
                  "email_validate_message": "Please validate bad emails",
                  "select_role_validate_msg": "Select a role",
                  "add_multiple_learners": "Add Multiple Learners",
                  "generate_dummy_learner": "Generate Learner with Login Alias"
              },
              "invite_multiple_users": {
                  "title": "Invite Learners"
              },
              "edit_user": {
                  "update_success": "Update success",
                  "title": "Edit Role User",
                  "user_title": "Select title",
                  "user_title_placeholder": "Title",
                  "department": "Select department",
                  "department_placeholder": "Department",
                  "department_validation_msg": "please enter a department",
                  "title_validation_msg": "please enter a title",
                  "role_validation_msg": "please select a role"
              },
              "disable": {
                  "title": "Disable {numberOfAccounts} user accounts",
                  "message": "Are you sure you want to revoke pro licenses for {numberOfAccounts} users?",
                  "confirm": "Yes, Revoke",
                  "cancel": "No, Cancel"
              },
              "delete": {
                  "title": "Remove users from organization",
                  "message": "Are you sure you want to remove {numberOfAccounts} user(s) from your organization?",
                  "confirm": "Yes, Remove",
                  "cancel": "No, Cancel"
              },
              "delete_from_class": {
                  "title": "Remove users from team",
                  "message": "Are you sure you want to remove {numberOfAccounts} user(s) from your team?",
                  "confirm": "Yes, Remove",
                  "cancel": "No, Cancel"
              },
              "assign_license": {
                  "title": "Assign license to user",
                  "message": "Are you sure to assign {licenseDisplayName} license to {userDisplayName}?",
                  "confirm": "Yes, Continue",
                  "cancel": "No, Cancel"
              },
              "invite_multiple": {
                  "email_validation_msg": "Please input correct email address",
                  "firstname_validation_msg": "Please input first name",
                  "lastname_validation_msg": "Please input last name",
                  "add_single_learner": "Add single learner"
              },
              "invite_learners": {
                  "email_validate_msg": "Please input correct email address",
                  "first_name_validation_msg": "Please input first name",
                  "last_name_validation_msg": "Please input last name"
              },
              "invite_teacher": {
                  "first_name": "First name",
                  "last_name": "Last name",
                  "email_validation_msg": "Please input correct email address",
                  "first_name_validation_msg": "Please input first name",
                  "last_name_validaion_msg": "Please input last name"
              },
              "export_report": {
                  "message": "We're generating the report and this can take a few minutes. You will receive the report via email shortly."
              }
          },
          "popovers": {
              "groups": {
                  "title": "Add to Group",
                  "add_group": "Add group",
                  "manage_groups": "Manage groups"
              },
              "classes": {
                  "title": "Add to Class",
                  "new_class": "New class"
              },
              "roles": {
                  "title": "Edit Roles"
              },
              "user": {
                  "title": "Edit User Information"
              }
          }
      },
      "invite_users": {
          "title": "Invite Users",
          "subtitle": "Invite users to join your company:",
          "import_users": "Import list of email addresses",
          "import_users_classes": "Import list of email addresses to many groups",
          "share_link": "Share a link",
          "mail_invite": "Copy and paste email addresses",
          "multiple_mail_invite_with_enrolled": "{numberOfInvites} user(s) have been enrolled to the group",
          "multiple_mail_invite": "{numberOfInvites} user(s) have been invited",
          "multiple_mail_to_invite": "{numberOfInvites} user(s) will be invited",
          "import": {
              "elsa-title": "import list of Elsa user IDs",
              "title": "import list of email addresses",
              "subtitle": "Import list",
              "instructions": "Drag and drop your files here to upload them.",
              "files": "{fileCount} file(s) have been uploaded",
              "instructions2": "Download the template in",
              "instructions3": "drag and drop below to import",
              "get_template": "Get template",
              "get_template_xlsx": "MS Excel format",
              "get_template_csv": "CSV format",
              "browse_files": "Browse files"
          },
          "mail": {
              "title": "Copy and paste email addresses"
          },
          "confirmation_title": "Confirmation",
          "select_a_membership": "Select a membership",
          "available_licenses": "Available licenses:",
          "click_to_assign": "Click to assign licenses to learners",
          "assign_all": "Assign All",
          "clear_all": "Clear All",
          "assign_license": {
              "table": {
                  "email": "Email",
                  "first_name": "First Name",
                  "last_name": "Last Name",
                  "class": "Class",
                  "license": "License"
              },
              "title": "Assign License",
              "invite_only": "Invite only, no license needed"
          }
      },
      "edit_org_teacher": {
          "first_name": "First name",
          "last_name": "Last name",
          "first_name_validation_msg": "Please input first name",
          "last_name_validation_msg": "Please input last name"
      },
      "import_user": {
          "title": "Import users"
      },
      "add_user_to_team": "Add {0} to the team",
      "join_org": {
          "enter_invitation_code": "Enter invitation code",
          "email_validation": "Please input correct email address"
      },
      "plan": {
          "title": "Groups • {0} • Plan  & Payment",
          "plan_title": "Plan & Payment",
          "learners": "{0} Learners",
          "user_month": "{0}/user/month",
          "redeem_by": "Redeem by:",
          "used": "Used:",
          "licenses": "{0} license(s)",
          "contract_to_use_license_s": "{0} license(s)",
          "to_use": "To use:",
          "activated": "(activated)",
          "order_id": "Order ID:",
          "billing_cycle": "Billing cycle:",
          "purchase_date": "Purchase date:",
          "next_billing_date": "Next billing date:",
          "payment_method": "Payment method:",
          "next_billing_amount": "Next billing amount:",
          "buy_more_packages": "Buy More Packages",
          "billing_history": "Billing History",
          "order_number": "Order number",
          "purchase_date_table_header": "Purchase date",
          "plan_type": "Plan type",
          "amount": "Amount",
          "number_of_licenses": "Number of licenses",
          "transaction_type": "Transaction type",
          "elsa_pro_1_year": "ELSA Pro 1 Year",
          "elsa_pro_6_months": "ELSA Pro 6 Months",
          "elsa_pro_3_months": "ELSA Pro 3 Months",
          "elsa_pro_1_month": "ELSA Pro 1 Month",
          "annual": "Annual",
          "semi_annual": "Semi-annual",
          "quarterly": "Quarterly",
          "medium": "Medium",
          "lite": "Lite",
          "yearly": "Yearly",
          "every_6_months": "Every 6 months",
          "every_3_months": "Every 3 months",
          "every_1_month": "Every 1 month",
          "turn_off_auto_renewal": "Turn off auto-renewal",
          "expired": "Expired:",
          "change_payment_details": "Change payment details"
      }
  },
  "table_row": {
      "actions": {
          "remove_from_group": "Remove from group",
          "add_to_class": "Add to class",
          "disable": "Disable",
          "delete": "Delete"
      }
  },
  "organization_profile": {
      "title": "Profile",
      "admins": "Admins",
      "date_joined": "Date Joined",
      "add_associate_admin": "Add Associate Admin",
      "pending_request": "Pending Request",
      "organization_name": "Organization Name",
      "organization_username": "Organization Username",
      "organization_type_industry": "Organization Type/Industry",
      "phone": "Phone Number",
      "address": "Address",
      "affiliate": "Affiliate",
      "admin_actions": {
          "remove_from_admin": "Remove",
          "edit_user": "Edit User",
          "remove_from_organization": "Remove",
          "change_default_admin": "Change to Default Admin",
          "change_associate_admin": "Change to Associate Admin",
          "user_id_only_admin": "Cannot remove the only admin of an organization."
      },
      "remove_admin_modal": {
          "title": "Remove Admin",
          "yes_remove": "Remove",
          "no_cancel": "Cancel",
          "add": "Add",
          "msg_no_longer_admin": "{0} will no longer has assess to manage the account as Default Admin."
      },
      "add_role_to_user": {
          "title": "Change Role",
          "message": "Are you sure to change {userAssociateName}'s role to {roleDisplayName}?",
          "yes_associate": "Change",
          "no_cancel": "Cancel"
      },
      "invite_admin_modal": {
          "invite_success": "Invitation has been sent.",
          "remove_invite_success": "Remove invitation successfully",
          "remove_invite_fail": "Remove invitation unsuccessfully",
          "confirm_remove_invitation": "Do you want to remove this invitation?",
          "title": "Invite New Admin",
          "email_field": {
              "label": "Email Address",
              "placeholder": "Enter email address"
          },
          "invite_button": "Invite",
          "cancel_button": "Cancel",
          "invite_admin_desc": "Associate Admins can only Create Teams, Set Goals, and Invite Learners. They do not have access to Account, Contract, Plans & Payment.",
          "first_name": "First name",
          "last_name": "Last name",
          "email_validation_msg": "Please input correct email address",
          "name_validation_msg": "Please input first name",
          "last_name_validation_msg": "Please input last name",
          "create_button": "Create Learner"
      },
      "delete_disable_organization_modal": {
          "title_delete": "Delete",
          "title_disable": "Disable",
          "title_enable": "Enable",
          "password_field": {
              "label": "password",
              "placeholder": "Enter password",
              "validation_msg": "Please input your password"
          },
          "delete_button": "Delete organization",
          "disable_button": "Yes, disable",
          "enable_button": "Yes, enable",
          "cancel_button": "Cancel",
          "delete_terms": "I understand I will lose access to my history data and my current licenses.",
          "disable_terms": "I understand users will lose their payed licenses.",
          "are_you_sure_disable": "Are you sure you want to disable",
          "are_you_sure_enable": "Are you sure you want to enable",
          "are_you_sure_widthraw": "Are you sure you want to withdraw from",
          "if_so_fill_following": "If so, please provide the following information:"
      },
      "edit_organization_modal": {
          "invite_not_send": "Organization was created, but invitations could not be sent.",
          "update_success": "Organization has been updated",
          "update_feature_accesss_success": "Feature access has been updated",
          "create_success": "Organization has been created",
          "create_title": "Create new organization",
          "edit_title": "Edit organization",
          "save": "Save",
          "cancel": "Cancel",
          "upload_logo_field": {
              "label": "Upload logo"
          },
          "verified_organization": "Verify organization",
          "enable_organization": "Enable organization",
          "disable_organization": "Disable organization",
          "delete_organization": "Delete organization",
          "are_you_sure_disable": "Are you sure you want to disable",
          "name_field": {
              "label": "Organization Name",
              "placeholder": "Enter organization name"
          },
          "code_field": {
              "label": "Organization Code",
              "placeholder": "Enter organization code"
          },
          "username_field": {
              "label": "Username",
              "placeholder": "Enter organization username"
          },
          "org_type_field": {
              "label": "Organization type",
              "placeholder": "Select organization type"
          },
          "industry_field": {
              "label": "Industry",
              "placeholder": "Select industry"
          },
          "address_field": {
              "label": "Address",
              "placeholder": "Enter organization address",
              "validation_msg": "Please input a address"
          },
          "phone_field": {
              "label": "Phone number",
              "placeholder": "+1-000-000-0000",
              "validation_msg": "Please input a phone",
              "validation_number_msg": "Phone should be a number"
          },
          "country_field": {
              "label": "Country",
              "placeholder": "Enter country",
              "validation_msg": "Please pick a country"
          },
          "state_field": {
              "label": "State/Province",
              "placeholder": "Enter state/province",
              "validation_msg": "Please input a state"
          },
          "city_field": {
              "label": "City",
              "placeholder": "Enter city",
              "validation_msg": "Please input a city"
          },
          "post_code_field": {
              "label": "Postal Code",
              "placeholder": "Postal Code",
              "validation_msg": "Please pick a postcode"
          },
          "owner_field": {
              "label": "Organization Admin",
              "placeholder": "Enter Email",
              "required_validation_msg": "Please input an account owner",
              "email_validation_msg": "Invalid owner email"
          },
          "affiliate_field": {
              "label": "Affiliate",
              "placeholder": "None"
          },
          "timezone_field": {
              "label": "Timezone",
              "placeholder": "Etc/GMT",
              "tooltip_change": "Please note: All learners in our organization use this timezone on the ELSA Speak app. \nChanging it will affect everyone's schedule. In case you can not change, please contact our support team at b2bsupport@elsanow.io.",
              "tooltip_create": "Please note: All learners in our organization use this timezone on the ELSA Speak app. \nPlease choose the timezone that is most relevant to your organization.",
              "confirm_desc": "Please note: All learners in our organization use this timezone on the ELSA Speak app. \nChanging it will affect everyone's schedule."
          },
          "learner": {
              "first_name": "First name",
              "last_name": "Last name",
              "first_name_validation_msg": "Please input first name",
              "last_name_validation_msg": "Please input last name"
          },
          "code": "Code",
          "organization_validation": "Please input organization name",
          "_organization_type_validation": "Please pick a organization type",
          "industry_validation": "Please pick an industry",
          "nativelanguage_field": {
              "label": "Native Language",
              "placeholder": "Native Language"
          },
          "purchasedproduct_field": {
              "label": "Purchased Products",
              "placeholder": "Purchased Products"
          },
          "parent_field": {
              "label": "Parent",
              "placeholder": "Select parent this organization"
          },
          "countries_content_restrict_field": {
              "label": "Countries Content Restriction",
              "placeholder": "Countries Content Restriction"
          },
          "use_dummy_email": "Use Login Alias",
          "use_custom_assessment": "Use Custom Assessment"
      },
      "view_dummy_email_credential_modal": {
          "dummy_email_credential": "Login Alias Credential",
          "email_label": "Email",
          "password_label": "Password"
      },
      "change_pass_dummy_modal": {
          "change_pass_dummy_title": "Change Password",
          "new_password": "New Password",
          "confirm_password": "Confirm Password",
          "new_password_required": "Please input new password",
          "confirm_password_required": "Please input confirm password",
          "new_password_min": "Password must be at least 8 characters long",
          "confirm_password_min": "Password must be at least 8 characters long"
      }
  },
  "admin": {
      "organizations": {
          "title": "Organizations",
          "create_new_organization": "Create new organization",
          "import_organizations": "Import organizations",
          "verify": "Verify",
          "table": {
              "verification": "Verification",
              "unredeemed_licenses": "Unredeemed Licenses",
              "not_verified": "Not Verified",
              "verified": "Verified",
              "organization_name": "Organization name",
              "status": "status",
              "licences": "Licenses",
              "empty": "No organization found",
              "active": "Active",
              "inactive": "Disabled",
              "country": "country",
              "created_at": "Creation date",
              "expected_renewal": "Expected Renewal",
              "contract_end": "Contract End",
              "out_of_total": " out of {total}"
          },
          "filter_menu": {
              "all": "All",
              "active": "Active",
              "disabled": "Disabled",
              "verified": "Verified",
              "filter_by_country": "Filter by country",
              "filter_by_org_type": "Filter by organiztion type"
          }
      },
      "invite_admin": "Invite Admin"
  },
  "organization_page": {
      "organizations": "Organizations",
      "disable": "Disable",
      "delete": "Delete",
      "menu": {
          "licences": "Licenses",
          "users": {
              "title": "Users",
              "all_users": "All users",
              "employees": "Employees",
              "leads": "Team Leads",
              "admins": "Admins"
          },
          "groups": "Groups",
          "profile": "Profile",
          "contract": "Contract",
          "admins": "Admins",
          "feature_access": "Feature Access",
      }
  },
  "disable_organization_modal": {
      "title": "Disable",
      "yes_disable": "Yes, disable",
      "no_cancel": "No, cancel",
      "are_you_sure": "Are you sure you want to disable Organization A? Users will not be able to access their licenses while the organization is disable."
  },
  "onboarding": {
      "welcome": "Welcome to ELSA",
      "welcome_subtitle": "Tell us a bit more about yourself so we can guide you on your ELSA journey.",
      "who_are_you": "Who are you?",
      "select_option": "Select one of the options below",
      "school": "School",
      "school_admin": "School Admin",
      "company": "Company",
      "company_admin": "Company Admin",
      "teacher": "Teacher",
      "student": "Learner",
      "continue": "Continue",
      "you_do_not_belong_to_any_org": "You do not belong to any organization"
  },
  "school": {
      "setup_school": {
          "successfully_created": "Your school was successfully created.",
          "setup_your_school": "Set up your school",
          "invite_students_teachers": "Invite your learners and teachers to join your organization.",
          "create_your_first_class": "Create your first class!",
          "create_class": "Create class",
          "invite_teachers": "Invite teachers",
          "invite_students": "Invite learners",
          "teacher": "Teacher",
          "continue": "Continue"
      },
      "create_edit_modal": {
          "title": "Create School",
          "create": "Create",
          "cancel": "Cancel",
          "name_field": {
              "label": "School name",
              "placeholder": "Enter school name",
              "validation_msg": "Please input school name"
          },
          "username_fields": {
              "label": "Username",
              "placeholder": "Enter school username",
              "validation_msg": "Please input school username"
          },
          "type_field": {
              "label": "School Type",
              "placeholder": "Select school type"
          },
          "industry_field": {
              "label": "Industry",
              "placeholder": "Select industry",
              "validation_msg": "Please pick an industry"
          },
          "address_field": {
              "label": "Address",
              "placeholder": "Select school address",
              "validation_msg": "Please pick a school address"
          },
          "phone_field": {
              "label": "Phone number",
              "placeholder": "+1-000-000-0000",
              "code": "Code",
              "validation_msg": "Please pick a school phone"
          },
          "country_field": {
              "label": "Country",
              "placeholder": "Enter country",
              "validation_msg": "Please pick a school country"
          },
          "state_field": {
              "label": "State/Province",
              "placeholder": "Enter state/province",
              "validation_msg": "Please pick a school state"
          },
          "city_field": {
              "label": "City",
              "placeholder": "Enter city",
              "validation_msg": "Please pick a school city"
          },
          "post_code_field": {
              "label": "Postal Code",
              "placeholder": "0000-00",
              "validation_msg": "Phone should be a number",
              "required_validation_msg": "Please pick a school postcode",
              "number_validation_msg": "Postcode should be a number"
          },
          "school_type": {
              "validation_msg": "Please pick a school type",
              "youtube_type_1": "Youtube Type 1",
              "youtube_type_2": "Youtube Type 2",
              "youtube_industry_1": "Youtube Industry 1",
              "youtube_industry_2": "Youtube Industry 2"
          }
      }
  },
  "company": {
      "setup_company": {
          "successfully_created": "Your company was successfully created.",
          "setup_your_company": "Set up your company",
          "invite_students_teachers": "Invite your learners and teachers to join your company.",
          "create_class": "Create class",
          "invite_teachers": "Invite teachers",
          "invite_students": "Invite learners",
          "continue": "Continue"
      },
      "create_edit_modal": {
          "title": "Create company",
          "create": "Create",
          "cancel": "Cancel",
          "name_field": {
              "label": "Company Name",
              "placeholder": "Enter company name",
              "validation_msg": "Please input company name"
          },
          "username_field": {
              "label": "Company username",
              "placeholder": "Enter company username",
              "validation_msg": "Please input company username"
          },
          "type_field": {
              "label": "Company type",
              "placeholder": "Enter company type",
              "validation_msg": "Please pick a company type"
          },
          "industry_field": {
              "label": "Industry type",
              "placeholder": "Enter industry",
              "validation_msg": "Please pick an industry"
          },
          "address_field": {
              "label": "Address",
              "placeholder": "Enter school address",
              "validation_msg": "Please pick a company address"
          },
          "phone_field": {
              "label": "Phone number",
              "placeholder": "+1-000-000-0000",
              "code": "Code",
              "code_validation_msg": "Please pick a company phone",
              "validation_msg": "Phone should be a number"
          },
          "country_field": {
              "label": "Country",
              "placeholder": "Enter country",
              "validation_msg": "Please pick a company country"
          },
          "state_field": {
              "label": "State/Province",
              "placeholder": "Enter state/province",
              "validation_msg": "Please pick a company state"
          },
          "city_field": {
              "label": "City",
              "placeholder": "Enter city",
              "validation_msg": "Please pick a company city"
          },
          "post_code_field": {
              "label": "Postal code",
              "placeholder": "0000-00",
              "required_validation_msg": "Please pick a company postcode",
              "number_validation_msg": "Postcode should be a number"
          },
          "company_type": {
              "youtube_type_1": "Youtube Type 1",
              "youtube_type_2": "Youtube Type 2",
              "youtube_industry_1": "Youtube Industry 1",
              "youtube_industry_2": "Youtube Industry 2"
          }
      }
  },
  "teacher": {
      "are_you_part_of_organization": "Are you part of an organization?",
      "select_one_options": "Select one of the options below",
      "yes": "Yes",
      "no": "No",
      "teach_myself": "I teach by myself",
      "continue": "Continue",
      "do_you_have_invitation_code": "Do you have an invitation code?",
      "enter_the_code": "Enter the code to join your organization"
  },
  "student": {
      "are_you_part_of_organization": "Are you part of an organization?",
      "select_one_options": "Select one of the options below",
      "yes": "Yes",
      "no": "No",
      "learning_myself": "I’m studying on my own",
      "continue": "Continue",
      "do_you_have_invitation_code": "Do you have an invitation code?",
      "edit_learner": "Edit Learner",
      "remove_learner": "Remove Learner",
      "theres_no_learner": "There's no learner in your organization yet",
      "invite_your_team": "Invite your team members so they can start learning with ELSA",
      "invite_learners": "Invite Learners",
      "theres_no_learner_in_org": "There's no learner in your organization yet",
      "theres_no_learner_in_class": "There's no learner in your class yet",
      "generate_dummy_learners": "Generate Learners with a Login Alias"
  },
  "setup_organization": {
      "join_your_organization": "Join your organization",
      "wait_for_admin": "Wait for your admin to send you an invitation or enter an invitation code.",
      "enter_invitation_code": "Enter invitation code",
      "continue": "continue",
      "welcome_to_organization": "Welcome to organization A",
      "you_can_create_own_class": "You can create your own class or wait for your admin to assign you to a class",
      "create_class": "Create class"
  },
  "start_learning": {
      "start_learning": "Start learning",
      "download_elsa_app": "Download the ELSA Speak app on your mobile device:",
      "or_send_the_email_by_link_sms": "Or get a download link by email or SMS/text message:",
      "send_email_link": "send me a link via email",
      "send_sms_link": "send me a link via SMS",
      "start_practice": "Start practicing",
      "you_can_download": "You can download the app and start practicing:",
      "to_join_our_organization": "To join your organization, wait for your admin to invite you or enter an invite code",
      "enter_invitation_code": "Enter invitation code",
      "email_link_sent": "Link sent via email",
      "sms_link_sent": "Link sent via SMS",
      "get_email_link_modal": {
          "title": "Get link via email",
          "get_email_link": "Get link via email",
          "email_field": {
              "label": "Email",
              "placeholder": "Enter email address",
              "validation": "Please input correct email address"
          },
          "phone_type_field": {
              "label": "Type of phone",
              "placeholder": "Type of phone"
          },
          "success": "Email was sent",
          "warning": "Email could not be sent, try again later"
      },
      "send_sms_link_modal": {
          "title": "Get link via SMS",
          "get_sms_link": "Get link via SMS",
          "phone_type_field": {
              "label": "Type of phone",
              "placeholder": "Type of phone"
          },
          "phone_field": {
              "label": "Phone",
              "placeholder": "+1-000-000-0000",
              "code": "Code",
              "validation_msg": "Phone should be a number"
          },
          "success": "SMS was sent",
          "warning": "SMS could not be sent, try again later",
          "email_validation_msg": "Please input correct email address"
      }
  },
  "industries": {
      "aerospace": "Aerospace",
      "transportation": "Transportation",
      "computer_software_internet": "Computer, Software, & Internet",
      "telecommunication": "Telecommunications",
      "food_and_agriculture": "Food & Agriculture",
      "construction": "Construction",
      "education": "Education",
      "healthcare": "Healthcare",
      "travel_and_hospitality": "Travel and Hospitality",
      "entertainment_news_media_music": "Entertainment, News, & Media",
      "energy": "Energy",
      "manufacturing": "Manufacturing",
      "fashion_and_clothing": "Fashion & Clothing",
      "mining": "Mining",
      "consulting_services": "Consulting/Services",
      "other": "Other"
  },
  "study_sets": {
      "curriculum": "Curriculum",
      "no_study_sets_yet": "There is no study set for now",
      "delete_study_set_success": "Delete study set successfully",
      "delete_study_set_warning": "Delete study set unsuccessfully",
      "create_study_set": "Create Study Set",
      "add_study_set": "Add a New Study Set",
      "your_study_set": "Your Study Set",
      "review_confirm": "Review and Confirm",
      "copy_of_study_set_name": "Copy of {name}",
      "back": "Back",
      "study_set": "Study Set",
      "information": "Information",
      "success_class_updated": "Study Set was successfully updated",
      "success_class_duplicated": "Study Set was successfully duplicated",
      "assignment_name": "Assignment Name",
      "assigned_to": "Assigned To",
      "assign_to": "Assign To",
      "start_on": "Start On",
      "start_time": "Start Time",
      "start_date": "Start Date",
      "due_on": "Due On",
      "due_time": "Due Time",
      "due_date": "Due Date",
      "set_reminder": "Set Reminder",
      "before_the_due_day": "before the due day.",
      "before_the_due_date": "before the due date",
      "phrases_count": "Items",
      "phrases": "Items",
      "assigned_on_date": "Assigned on {date}",
      "menu": {
          "study_sets": "Study Sets",
          "all_assignments": "Assignments",
          "read_aloud": "Read Aloud",
          "role_play_scenario": "AI Role-Plays"
      },
      "table": {
          "search_study_set_name": "Search study set name",
          "study_set_name": "Study set name",
          "last_updated": "Last updated",
          "category": "Category",
          "phrases": "Items",
          "shareable_to": "Shareable To",
          "edit": "Edit",
          "duplicate": "Duplicate",
          "remove": "Delete",
          "skills": "Skills",
          "search_hint": "Type in at least the first 3 letters",
          "created_by": "Created By",
          "other": "Other"
      },
      "form": {
          "study_set_name": "Study set name",
          "name_your_study_set": "Name your study set",
          "category": "Category",
          "input_phrases": "Input words, phrases, sentences",
          "shareable_to": "Make content shareable to",
          "phrases": "Phrases",
          "type_in_phrases_press_enter_to_seperate": "Type or copy and paste here, using “;” to separate the items.",
          "cancel": "cancel",
          "next": "Next",
          "more_actions": "More actions",
          "name_your_assignment": "Name your assignment"
      },
      "errors": {
          "please_provide_name": "Please provide a name",
          "please_provide_category": "Please provide a category",
          "please_provide_shareable_to": "Please provide a shareable to",
          "please_provide_assignment_name": "Please provide assignment name",
          "please_provide_start_on": "Please provide start date",
          "please_provide_due_on": "Please provide due date"
      },
      "create_studyset_flow": {
          "save_finish_later": "Save and finish later",
          "cancel": "Cancel",
          "save": "Save",
          "next": "Continute",
          "previous": "Back to edit",
          "details": "Details"
      },
      "overview": {
          "study_set_name": "Study set name",
          "shareable": "Shareable To",
          "category": "Category",
          "phrases_count": "Number of items",
          "created_by": "Created by",
          "phrases_list_title": "Items",
          "phrases_add_success": "This item was successfully added",
          "phrases_add_fail": "This item was not added to your study set.",
          "phrases_add_changed": "This item was clean-up, the original text is:{original_text}"
      },
      "modals": {
          "cancel": {
              "title": "Are you sure you want to leave?",
              "decs": "The changes you’ve made will not be saved.",
              "cancel": "Stay on this page",
              "confirm": "Leave"
          },
          "createSuccess": {
              "message": "New study set has been\nsuccessfully created!",
              "study_set_name_label": "Study set name",
              "count_of_item_label": "Count of items",
              "done": "Done",
              "create_another_study_set": "Create another study set"
          },
          "createAssignmentSuccess": {
              "new_assignments_status": "New assignments status",
              "assign_to_class_successfully": "Assigned to class successfully!",
              "assignment_name": "Assignment name",
              "assigned_to": "Assigned to",
              "due_date": "Due date"
          },
          "delete": {
              "confirm": "Delete",
              "cancel": "Cancel"
          },
          "addAssignment": {
              "add_assignment": "Add Assignment",
              "choose_study_set": "Choose Study Set",
              "add_study_set": "Add Study Set",
              "other_settings": "Other Settings",
              "select_study_mode": "Choose a Study Mode",
              "study_mode_1": "Pronunciation Skills",
              "study_mode_4": "Vocabulary Skills",
              "assign_an_assessment": "Assign an Assessment",
          },
          "spell_check": {
              "desc": "Looks like some of your items have errors. Proceed anyway?",
              "back_to_edit": "Back to edit",
              "proceed": "Proceed"
          },
          "edit_class": {
              "title_save": "Save Class And Assign License",
              "description": "Are you sure you want to save the Class Detail and License changes?"
          },
          "cancelEdit": {
              "title": "Discard unsaved changes?",
              "cancel": "Continue editing",
              "confirm": "Discard"
          },
          "modal_check": {
              "spell_desc": "Looks like some of your items have errors. Proceed anyway?",
              "limit_desc": "An item can not exceed 300 characters. Please check for extra space or try to rephrase or remove unnecessary characters.",
              "back_to_edit": "Back to edit",
              "proceed": "Proceed"
          }
      },
      "messages": {
          "your_study_set_has_been_created_successfully": "Your study set has been created successfully!",
          "your_study_set_has_been_updated_successfully": "Your study set has been updated successfully!"
      },
      "assign_to_class": "Assign to class",
      "delete": "delete",
      "remove_the_word": "remove the word",
      "add": "add",
      "ignore_all": "Ignore all",
      "replace_all": "Replace all",
      "edit_study_set": "Edit Study Set",
      "save_changes": "Save Changes",
      "edit_disabled_message": "This study set is included in an active assignment. It can not be edited to avoid affecting your learners' progress."
  },
  "assignments": {
      "class_assignment": "Class Assignment",
      "add_assignment": "Add Assignment",
      "delete_assignment_success": "Delete assignment successfully",
      "delete_assignment_warning": "Delete assignment unsuccessfully",
      "table": {
          "name": "Assignment Title",
          "timeline": "Timeline",
          "max_score": "Max. Score",
          "min_score": "Min. Score",
          "avg_score": "Avg. Score",
          "submitted_ontime": "Submitted On time",
          "submitted_late": "Submitted Late",
          "missed": "Missed"
      },
      "modals": {
          "no_study_sets": {
              "title": "Add Assignment",
              "desc": "You have no study set in your Curriculum to perform this action.",
              "action": "Create study set now"
          },
          "cancel": {
              "decs_line_1": "You are in the process of creating a new assignment for your students.",
              "decs_line_2": "Are you sure you want to cancel?",
              "continue": "Continue",
              "cancel": "Cancel"
          },
          "assignment_history": "Assignment History - {title}"
      },
      "messages": {
          "your_assignment_has_been_created_successfully": "The assignment has been sent out to your learners",
          "your_assignment_has_been_updated_successfully": "Your study set has been updated successfully!"
      },
      "details": {
          "back_to_assignment_list": "Back to Assignment List",
          "start_on": "Start on",
          "due_on": "Due on",
          "reminder_sent": "Reminder",
          "information": "Assignment Details",
          "performance": "Score Results",
          "performance_lesson": "Learner Performance",
          "study_set_name": "Study Set Title",
          "count_of_items": "Count of items",
          "category": "Category",
          "name": "Name",
          "score": "Highest Score",
          "date_completed": "First Completion",
          "overall_result": "Overall Assignment Results",
          "detail_result": "Lesson Performance",
          "overall_result_overall_score": "Overall Assignment Score",
          "overall_result_max_score": "Highest Indiv. Score",
          "overall_result_average_score": "Average Score",
          "overall_result_min_score": "Lowest Indiv. Score",
          "overall_result_submissions": "Submissions",
          "overall_result_submissions_out_of": "out of",
          "overall_result_submission_on_time": "On time",
          "overall_result_submission_late": "Late",
          "overall_result_submission_missed": "Missed",
          "detail_result_lesson_name": "Lesson Name",
          "detail_result_results": "Results",
          "performance_name": "Name",
          "performance_score": "Highest Score",
          "performance_date_complete": "First Completion",
          "performance_tooltip": {
              "score": "This is highest score the learner gets for the assignment if they do the assignment many times",
              "date_complete": "This is the date when the assignment was first completed by the leaner if they do the assignment many times"
          },
          "class": "Class",
          "timeline": "Timeline",
          "edit_timeline": "Edit Timeline",
          "confirm": "Confirm",
          "cancel": "Cancel",
          "days": "{0} day(s)",
          "before_due": "before the due day",
          "edit_name": "Edit Title",
          "date_timestamp": "Date-timestamp",
          "overall_score": "Overall Score",
          "warm_up_study_set": "Warm-Up Study Set",
          "eps": "EPS",
          "fluency": "Fluency",
          "pronunciation": "Pronunciation",
          "intonation": "Intonation",
          "highest_assignment_score": "Assignment Score (HIGHEST)",
          "warm_up_study_set_high_score": "Warm-Up Study Set High Score",
          "read_aloud_overall_high_score": "Read Aloud Overall High Score",
          "eps_high_score": "EPS High Score",
          "fluency_high_score": "Fluency High Score",
          "pronunciation_high_score": "Pronunciation High Score",
          "intonation_high_score": "Intonation High Score",
          "lesson_title": "Lesson Title",
          "class_average": "Class Average",
          "lesson_score": "Lesson Score (Mean)",
          "vocabulary": "Vocabulary (Median)",
          "grammar": "Grammar (Median)"
      },
      "modals_edit_timeline": {
          "title": "Timeline has been updated successfully.",
          "description": "Your learners will receive a notification about this change.",
          "button_text": "OK"
      },
      "report": {
          "export_report": "Export Report",
          "overall_report": "Overall report",
          "detailed_report": "Detailed report",
          "both": "Both"
      }
  },
  "classes": {
      "accepted_users": "Accepted users",
      "pending_users": "Pending users",
      "success_class_updated": "Class was successfully updated",
      "success_remove_user": "Remove users from class successfully",
      "reports": "Reports",
      "filter_menu": {
          "all": "All",
          "active": "Active",
          "not_started": "Not Started",
          "draft": "Drafts",
          "finished": "Finished"
      },
      "table_titles": {
          "start_date": "Start Date",
          "end_date": "End Date",
          "status": "Status"
      },
      "classes_details": {
          "left": " left",
          "to_go": " to go",
          "edit_class_name": "Edit {name}",
          "menu": {
              "overview": "Overview",
              "detailed_progress": "Detailed Progress",
              "time_tracking": "Time Tracking",
              "assignment": "Assignment",
              "assessment": "Assessment",
              "ai_role_play_log": "AI Role-Play Log"
          },
          "overview_section": {
              "title": "Overview Information",
              "students": "learners",
              "view_list": "View List",
              "goals": "Goals",
              "no_goals_set": "No goals is set for this class.",
              "minutes_per_day": "Minutes per day",
              "days_practice_per_week": "days of practice per week",
              "set_goals": "Set goals",
              "assessment_test_results": "Assessment test result",
              "average_score": "Class Average Score",
              "test_before_class_stats": "Days to take the assessment test"
          },
          "students_section": {
              "title": "Learners",
              "pro_licence": "Pro License",
              "assessment_test": "Assessment Score",
              "pronunciation": "Pronunciation",
              "intonation": "intonation",
              "fluency": "fluency",
              "word_linkage": "word linkage",
              "ending_sounds": "ending sounds",
              "pausing": "pausing",
              "pace": "pace",
              "text": "text",
              "volume": "volume",
              "date_take_assessment": "Assessment Date",
              "last_active_practice": "Last Practice Time",
              "practice_days_week": "Practice days week",
              "min_spent": "Min. spent",
              "last_eps": "Last EPS",
              "lesson_count": "#Lesson",
              "avg_daily_use": "Av. daily use (min)",
              "copy_paste_emails": "Copy and Paste email addresses",
              "module_name": "Module Name",
              "lesson_name": "Lesson Name",
              "lesson_EPS": "lesson EPS",
              "lesson_take_date": "Date Lesson",
              "difficulty_level": "Difficulty Level",
              "skill_name": "Skill Name",
              "skill_score": "Score",
              "elsa_assessment": "ELSA Assessment",
              "mini_assessment": "Mini Assessment",
              "assessment": "Assessment",
              "assessment_filter": "Assessment Filter"
          },
          "activity_reports": {
              "title": "Activity Reports",
              "lessons_overview": "Lessons overview",
              "number_of_lessons_practiced": "Number of Lessons and Minutes Practiced",
              "average_practice": "Average Practice Time (Minutes)",
              "progress": "Progress Chart (Average EPS)",
              "progress_student": "Progress Chart (EPS)",
              "0_5_percent": "0% - 5%",
              "6_10_percent": "6% - 10%",
              "11_50_percent": "11% - 50%",
              "50_70_percent": "51% - 70%",
              "mt_70_percent": "More than 70%",
              "number_of_studyset_practiced": "Number of Study Sets and Minutes Practiced",
              "51_70_percent": "51% - 70%"
          },
          "assessment": {
              "table": {
                  "date": "Last Assessment Date",
                  "eps": "Last Assessment Score",
                  "ons": "Pronunciation",
                  "sis": "Intonation",
                  "fls": "Fluency",
                  "overall_score": "Overall Score",
                  "word_linkage": "Word Linkage",
                  "ending_sounds": "Ending Sounds",
                  "pausing": "Pausing",
                  "pace": "Pace",
                  "text": "Text",
                  "btn_history": "History"
              }
          },
          "edit_class": {
              "available_licenses": "Available licenses:",
              "table": {
                  "email": "Email",
                  "first_name": "First Name",
                  "last_name": "Last Name",
                  "license": "License",
                  "title": "Assign License",
                  "invite_only": "Invite only, no license needed",
                  "exist_license": "Exist License"
              }
          },
          "conversation": {
              "table": {
                  "learner": "Learner",
                  "date": "Role-play Date-Time",
                  "senario": "Scenario",
                  "duration": "Duration",
                  "status": "Status",
                  "download_transcript": "Download Transcript",
                  "report_issue": "Report an Issue"
              }
          }
      },
      "create_class_flow": {
          "save_finish_later": "Save and finish later",
          "cancel": "Cancel",
          "save": "Save",
          "next": "Continute",
          "previous": "Go back",
          "details": "Details",
          "list_students_modal": {
              "got_it": "Got it!",
              "warning_no_student": "No learner will been invited"
          },
          "class_details": {
              "team_detail_tooltip": "Each team is required to have a name and an ELSA package",
              "start_end_date": "Start & End Date",
              "start_day": "Start date",
              "pick_a_day": "Pick a day",
              "end_date": "End date",
              "invalid_email_msg": "Invalid email"
          },
          "add_students": {
              "copy_paste_emails": "Copy and paste email addresses",
              "insert_multiple_emails": "Enter multiple emails (separated by commas)"
          },
          "class_overview": {
              "details": "Details",
              "start_end_date": "Start & End Date",
              "not_selected": "Not Selected",
              "create_and_send_invites": "Create and send invites"
          },
          "class_created": {
              "goals_section": {
                  "practice_at_least": "Practice at least",
                  "days_week": "days a week.",
                  "keep_them_engaged": "Keep them engaged on a weekly basis",
                  "practice": "Practice",
                  "minutes_day": "minutes a day.",
                  "studies_review": "Studies show practicing at least 10 minutes a day produces the best results when learning a new language.",
                  "take_assessment_test": "Take the Assessment Test",
                  "days_before_invitations": "days after invitation.",
                  "next": "Next",
                  "will_do_this_later": "I'll do this later.",
                  "assessment_test_desc": "Set the date when your team needs to complete the assessment.",
                  "first_assessment_test": "Complete before:",
                  "second_assessment_test": "Last assessment before:",
                  "pick_a_day": "Pick a day",
                  "send_reminders": "Send reminders:",
                  "learners": "Learners",
                  "table": {
                      "email": "Email",
                      "first_name": "First Name",
                      "last_name": "Last Name",
                      "license": "License",
                      "invite_only": "Invite only, no license needed"
                  }
              },
              "engage_with_your_students": "ENGAGE WITH YOUR STUDENTS",
              "class_created_and_invited": "Your class was created and 100 Students were Invited!",
              "congratulation": "CONGRATULATIONS!"
          },
          "available_licenses": "Available licenses:",
          "assign_licenses_to_learners": "Click to assign licenses to learners",
          "assign_all": "Assign All",
          "clear_all": "Clear All",
          "table": {
              "email": "Email",
              "first_name": "First Name",
              "last_name": "Last Name",
              "license": "License",
              "title": "Assign License",
              "invite_only": "Invite only, no license needed"
          }
      },
      "status": {
          "active": "Active",
          "finished": "Finished",
          "not_started": "Not Started",
          "pending": "Pending",
          "draft": "Draft"
      }
  },
  "dashboard": {
      "reports_overview": "Report Overview",
      "notifications": "Notifications",
      "overview": "Overview Information",
      "manage": "Manage",
      "licenses": "Licenses",
      "users": "Users",
      "request_license": "Request License",
      "student": {
          "view_class": "View class",
          "view_all_classes": "view All classes",
          "goals": {
              "minutes_per_day": "Goal of {minutes} minutes per day",
              "minutes_per_day_value": "Your Average is { minutes } minutes per day",
              "days_per_week": "Goal of {days} Days per Week",
              "days_per_week_value": "Your Average is {days} days of practice per Week",
              "level": "Level {level}",
              "level_value": "Average of {level}%"
          },
          "minutes_spend_per_day": "Minutes is the average time spent per day"
      },
      "your_class": "Your classes"
  },
  "charts": {
      "score": "Score",
      "active_users": "Active users",
      "avg_practice_time": "Average practice time",
      "avg_practicetime_perday": "Average practice time perday",
      "avg_eps": "EPS",
      "avg_eps_full": "Average EPS",
      "number_of_lessons": "# of Lessons",
      "number_of_seconds": "Time spent",
      "lessones_practices": "Lessons Practiced",
      "more_than_the_set_goal": "more than the set goal",
      "less_than_the_set_goal": "less than the set goal",
      "from_last_period": "from last period",
      "hours_practiced": "Hours Practiced",
      "hours_practiced_tooltip": "Value is rounded to the full hour.",
      "level_value": "Average of {level}%",
      "minutes_spent": "Minutes Spent",
      "minutes_practiced": "Minutes Practiced",
      "minutes_goal": "Minute goal",
      "hour_goal": "Hour goal",
      "hours_spent": "Hours Spent",
      "lessons_practiced": "Lessons Practiced",
      "user_eps_score": "EPS",
      "not_active": "Not active",
      "1_4_days": "1-4 days a week",
      "5_5_days": "5 days a week",
      "6_7_days": "6-7 days a week",
      "percentage": "Percentage",
      "average_elsa_score": "Average ELSA Score",
      "average_elsa_score_desc": "Based on results of learners in your organization",
      "average_elsa_score_title": "ORGANIZATION’S AVERAGE LEVEL",
      "pentagon_title": "ELSA score breakdown by skills",
      "pentagon_desc": "Based on results of individual",
      "ielts_title": "IELTS Speaking Score Predictor",
      "ielts_desc": "This score has not been approved or endorsed by IELTS or IDP",
      "no_ielts_data_title": "Not enough data from your learners yet.",
      "no_ielts_data_desc": "Encourage your learners to take the assessment tests or practice more lessons to get speaking score predictors.",
      "distribution_by_learners_title": "Distribution of learners",
      "distribution_by_learners_desc": "Calculated based on ELSA’ score range.",
      "ielts_score": {
          "no_data": "No data",
          "very_poor": "Very poor",
          "intermittent": "Intermittent",
          "extremely_limited": "Extremely limited",
          "limited": "Limited",
          "modest": "Modest",
          "competent": "Competent",
          "good": "Good",
          "very_good": "Very good",
          "expert": "Expert"
      },
      "elsa_score_range": {
          "native": "Native",
          "advanced": "Advanced",
          "intermediate": "Intermediate",
          "lower_intermediate": "Lower Intermediate",
          "beginner": "Beginner",
          "elementary": "Elementary"
      },
      "distribution_eps": {
          "learn_more": {
              "native": "Native: 90% or more",
              "advanced": "Advanced: 78% - 89%",
              "intermediate": "Intermediate: 67% - 77%",
              "lower_intermediate": "Lower Intermediate: 56% - 66%",
              "beginner": "Beginner: less than 56%"
          }
      },
      "average_elsa_score_historical_progress": {
          "titleY": "Average EPS (%)"
      },
      "lowest_average_score_skills_title": "Areas for Improvement",
      "highest_average_score_skills_desc": "Top Strongest Skills",
      "lowest_average_score_skills_desc": "Top Mistakes",
      "leaderboard": "Leaderboard",
      "learner_col_label": "LEARNER NAME",
      "score_col_label": "ELSA SCORE",
      "duration_col_label": "TIME PRACTICED",
      "lessons_total_col_label": "LESSONS PRACTICED",
      "highest_average_score_skills_title": "Individual's Accomplishments",
      "individualview_leaderboard_org_label": "Individual view",
      "tooltips": {
          "individual_eps": "Latest EPS score for the selected period",
          "individual_durations": "Total time practiced by the learner over the selected period in HH:MM:SS format",
          "individual_lessons_total": "Total number of lessons practiced by the learner",
          "branch_eps": "Up-to-date average score of all learners in the branch from selected period of time"
      },
      "mix": {
          "number_of_lessons": "Number of Lessons",
          "number_of_minutes": "Number of Minutes"
      },
      "total_learners": "TOTAL LEARNERS",
      "no_data": "No Data",
      "learn_more": "Learn more",
      "learner": "Learners",
      "skill_name": "Skill - {0}",
      "pronunciation": "Pronunciation",
      "fluency": "Fluency",
      "word_stress": "Word Stress",
      "listening": "Listening",
      "branchview_leaderboard_org_label": "Branch",
      "branch_col_label": "BRANCH",
      "number_of_studysets": "# of Study Sets",
      "time_spent": {
          "number_of_lessons": "ELSA Lessons",
          "number_of_studysets": "Study Sets",
          "number_of_seconds": "Practiced Time",
          "tooltip": {
              "lessons": "Total time spent on ELSA Lessons and number of ELSA lessons completed.",
              "studysets": "Total time spent on Study Sets and number of Study Sets completed."
          }
      }
  },
  "information": {
      "active_students": "If a learner uses the ELSA Speak app and finishes at least one lesson, that learner will be considered an active learner for that day",
      "active_students_chart": "In this chart, you can see the breakdown of learners active per day, week, or month based on the toggle you have selected to generate the reports.",
      "activity_reports_progress": "English proficiency score (EPS): global score representing the proficiency of the user in speaking English",
      "students_improvement": "This chart gives you a report on how your class/team have improved within the report duration base on EPS improvement",
      "export_report_button": "Export summary activity report in periods",
      "export_assessment_button": "Export all detail assessment test in periods",
      "export_lesson_detail_button": "Export all lesson detail report in periods",
      "assessment_test_col": "Representing the current EPS of the user in speaking English at the time of taking the assessment",
      "study_set_input_items": "Please note that an item should not exceed 140 characters (spaces included).",
      "reminder_tooltip": "A reminder will be sent to your learners as Push Notifications on their phones. Please specify the time when you want to remind your learners.",
      "show_from_to_of_total": "Showing {start} to {end} of {total}"
  },
  "contract": {
      "contract_start": "Contract Start",
      "contract_start_desc": "This is the date your contract starts",
      "contract_renewal": "Contract End",
      "contract_renewal_desc": "This is the date your contract ends",
      "learners": "Learners",
      "no_contract": "There are no contract.",
      "order_number": "Order number: "
  },
  "homework": {
      "set_reminder": "Set Reminder",
      "create_new_assignment": "Create New Assignment",
      "assignment_information": "Assignment Information",
      "lesson_sets": "Lesson Sets",
      "study_sets": "Study Sets",
      "remove": "Remove",
      "errors": {
          "please_provide_name": "Please provide a name",
          "please_provide_start_on": "Please provide start date",
          "please_provide_due_on": "Please provide due date",
          "please_provide_start_time": "Please provide start time",
          "please_provide_due_time": "Please provide due time"
      },
      "modals": {
          "delete": "We recommend keeping this item to have a complete set of lessons. Would you still like to proceed?",
          "delete_all": "Removing these items might impact the quality of your assignment. Would you still like to proceed?",
          "create_success": "Assignment created successfully!",
          "assign_to_class": {
              "assign_to_class": "Assign to Class",
              "selected_assignment": "Selected assignment",
              "select_a_class_to_assign_to": "Select a class to assign to",
              "assign_success": "Assignment has been assigned successfully!",
              "selected_assessment": "Selected Assessment"
          }
      },
      "tooltip": {
          "due_date": "This is the date by which learners should complete the assignment.",
          "start_date": "This is the date when the assignment becomes available to learners.",
          "set_reminder": "At the specified date and time, learners who have not yet completed the assignment will receive a push notification reminder."
      },
      "form": {
          "due_date": "Due Date",
          "start_date": "Start Date",
          "assignment_name": "Assignment Name",
          "assign_to": "Assign to",
          "start_time": "Start Time",
          "due_time": "Due Time",
          "before_the_due_date": "before the due date",
          "due_date_validate_msg": "0 day",
          "0_day": "0 day",
          "shareable": "Shareable To",
          "shareable_place_holder": "Select sharing permissions",
          "asignment_shareable_tooltip": "My Class Only: the assignment can only be viewed by teacher in class (owner class which you assign the assignment). \nMy Organization: the assignment visible by members of your organizations (e.g. admins and other teachers). \nBranch Only: the assignment only shared to your branches."
      },
      "buttons": {
          "select_lesson": "Select Lessons",
          "review": "Review",
          "create_assignment": "Create and Assign",
          "cancel": "Cancel",
          "back": "Back"
      },
      "create_assignment": {
          "skill": "SKILLS",
          "23_skills": "23 skills",
          "topics": "TOPICS",
          "15_categories": "15 categories",
          "game_types": "GAME TYPES",
          "6_game_types": "6 game types",
          "filter_by_level": "Filter by Level",
          "easy": "Easy",
          "medium": "Medium",
          "hard": "Hard",
          "difficult": "Difficult",
          "very_difficult": "Very difficult",
          "topic": "topic",
          "lesson_count": "lesson",
          "lessons_count": "lessons",
          "filter_by_english_level": "Filter by CEFR Level",
          "level_novice": "A1",
          "level_upper_beginner": "A2",
          "level_lower_intermediate": "B1",
          "level_upper_intermediate": "B2",
          "level_advanced": "C1",
          "mixed_level": "Mixed Level"
      },
      "lesson_set_levels": "{0} levels",
      "lesson_set_remove_all": "Remove All",
      "lesson_set_skill": "Skill {0} - ",
      "lesson_set_level": "Level {0} - ",
      "study_sets_title_skill": "Skill {0} - ",
      "study_sets_title_level": "Level {0} - ",
      "assignment_review": {
          "levels": "{0} levels",
          "remove_all": "Remove All",
          "skill": "Skill {0} - ",
          "level": "Level {0} -",
          "skill_label": "Skill - ",
          "topic_label": "Topic - ",
          "unit_label": "Unit - "
      },
      "head_section": {
          "input information": "Input Information",
          "select_lessons": "— Select Lessons",
          "review_assignment": "— Review Assignment"
      },
      "assignment_skill": {
          "levels": "{0} levels",
          "levels_label": "Levels",
          "level_label": "Level",
          "add_all_to_assignment": "Add all to assignment",
          "remove_all_from_assignment": "Remove all from assignment",
          "skill_title": "Skill {0} - ",
          "level_title": "Level {0} - ",
          "topic_title": "Topic {0} - ",
          "available_ios": " (Only available on IOS)",
          "available_android": " (Only available on Android)",
          "unit_title": "Unit {0} - "
      },
      "assignment_lib": {
          "table_selected_label": "{0} of {1} selected",
          "reset": "Reset",
          "confirm": "Confirm",
          "listening": "Listening",
          "pronunciation": "Pronunciation",
          "word_stress": "Word Stress",
          "conversation": "Conversation",
          "intonation": "Intonation",
          "study_sets": "Study Sets",
          "video_conversation": "Video Conversation",
          "click_to_sort": "Click to Sort",
          "reverse_sort_direction": "Reverse Sort Direction",
          "missing_character": "Missing Character",
          "unscramble_word": "Unscramble Word",
          "read_aloud": "Read Aloud",
          "ai_tutor": "AI Role-Plays"
      },
      "scenarios": {
          "title": "AI Role-Plays (Demo)",
          "assign_to_class": "Assign to Class",
          "assign_to_team": "Assign to Team",
          "objectives": "Scenario Goals:",
          "assign_modals": {
              "title": "Assign a Role-play Lesson",
              "selected_lesson": "Selected Lesson"
          }
      },
      "assessment": {
          "title": "Assessments",
          "table": {
              "name_label": "Assessment Name"
          }
      }
  },
  "homework_library": {
      "create_assignment": "Create Assignment",
      "search_assignment": "Search assignment",
      "table": {
          "assignment_name": "Assignment Name",
          "lesson_type": "Lesson Type",
          "created_on": "Created On",
          "recent_assigned_class": "Recent Assigned Class",
          "remove": "Remove",
          "assigned_to": "Assigned to",
          "due_date": "Due Date",
          "start_date": "Start date",
          "duplicate": "Create a Copy"
      },
      "created_on": "Created on:",
      "assigned_to": "Assigned to:",
      "class_assigned": "Class assigned",
      "remove_title": "You're about to remove assignment(s)!",
      "remove_desc": "The selected assignment(s) will only be removed from your Assignment Library. This won't affect your learners' work and their progress. ",
      "remove_success": "Delete assignment(s) successfully",
      "remove_warning": "Delete assignment(s) unsuccessfully",
      "duplicate_title": "Create a Copy and Edit",
      "duplicate_success": "A new copy of {name} has been created successfully",
      "create_success": "Assignment created successfully!",
      "curriculum": "Curriculum"
  },
  "plan_payment": {
      "tooltip_activated_warning": "These licenses have been auto-activated. You can still assign and redeem them before they expire on {date}",
      "tooltip_invalid_warning": "These licenses are no longer valid for use.",
      "tooltip_auto_active_warning": "You have 1 more week to redeem to licenses and use them for the full length of time.",
      "org_name_plan_title": "Groups • {0} • Plan & Payment",
      "title": "Plan & Payment",
      "desc": "View your plan, manage your payment method, and buy more packages.",
      "lite_annual": "Lite (Annual)",
      "lite_semi_annual": "Lite (Semi-annual)",
      "lite_quarterly": "Lite (Quarterly)",
      "medium_annual": "Medium (Annual)",
      "medium_semi_annual": "Medium (Semi-annual)",
      "medium_quarterly": "Medium (Quarterly)",
      "payment_method": {
          "title": "Payment method",
          "add_a_new_card": "Add a new card",
          "card_details": "Card details",
          "success_msg": "Your payment has been successfully processed. Please check your email for the receipt.",
          "failed_msg": "Payment failed! Please check your card details and try again."
      },
      "payment_summary": {
          "title": "Purchase summary",
          "sub_title": "Your subscription:",
          "user_month": "/user/month",
          "number_of_users": "Number of users",
          "total": "Total",
          "you_save": "You save {0}",
          "next_billing_date": "Your next billing date is",
          "can_cancel": "You can cancel your subscription before the next billing date to avoid future charges.",
          "subscribe": "Subscribe",
          "footer_term_1": "If you are buying for more than 100 users,",
          "footer_term_2": "contact sales",
          "footer_term_3": "for custom pricing."
      },
      "payment_plan": {
          "title": "Subscribe to a new plan",
          "select_a_plan": "Select a plan",
          "number_of_users": "Number of users",
          "your_benefits": "Your benefits:",
          "benefits": {
              "benefit_1": "ELSA Pro access",
              "benefit_2": "Over 3,000 lessons & exercises",
              "benefit_3": "Reporting & analytics",
              "benefit_4": "Custom assignments and lessons",
              "benefit_5": "English testing service for employees",
              "benefit_6": "Virtual onboarding sessions"
          }
      },
      "cancel_subscription": {
          "title": "Cancel Subscription",
          "desc": "We are sorry to see you go. If you cancel your subscription, from {date} onwards, your plan will stop auto-renew and you will not be billed for it. Thus, we will stop issuing new licenses for your organization and your learners will stop having the ELSA Pro benefits when their licenses expire.\n\n Your organization and learners still have all the benefits until the end of your current billing cycle: {date}. ",
          "keep_plan": "Keep plan",
          "cancel_anyway": "Cancel anyway",
          "confirm_title": "Are you sure you want to cancel your ELSA Pro Subscription?",
          "confirm_yes": "Yes, cancel my subscription",
          "confirm_no": "No, take me back",
          "success": "You have successfully cancelled your ELSA Pro Subscription"
      },
      "payment_details": {
          "title": "Payment Details",
          "desc": "Manage your payment method to ensure an uninterrupted learning experience for your organization.",
          "remove_card": "Remove card",
          "add_card": "Add a new card",
          "add_new_card": "Add New Card",
          "ending_in": "{method} ending in ••{number}",
          "expiry_date": "Expiry date: {month}/{year}",
          "cancel": "Cancel",
          "save_new_card": "Save New Card",
          "save_success_message": "Your new card has been saved successfully\n and will be used to make payment for your\n subscription from now on.",
          "close_text": "Yes, I got it"
      }
  },
  "contact": {
      "order_number": "Order number: "
  },
  "english_testing_service_for_employees": "English testing service for employees",
  "class_assessment_exporter": {
      "student_name": "Student Name"
  },
  "chart": {
      "intonation": "Intonation"
  },
  "teachers": {
      "title": "Teacher"
  },
  "style_guide": {
      "button_title": "Buttons {0}",
      "elsa_button": "Elsa Button",
      "elsa_primary_button": "Elsa Primary Button",
      "elsa_green_button": "Elsa Green Button",
      "elsa_secundary_button": "Elsa Secondary Button",
      "elsa_tertiary_button": "Elsa Tertiary Button",
      "checkbox_checklist": "Checkbox {0}",
      "option_a": "Option A",
      "radio_radio": "Radio {0}",
      "option_b": "Option B",
      "option_c": "Option C",
      "option_d": "Option D",
      "input_email_password": "Input {0}:{1}",
      "email": "Email",
      "password": "Password",
      "autocomplete_selected": "Autocomplete {0}",
      "elsa_input": {
          "password": {
              "placeholder": "Insert you password"
          },
          "email": {
              "placeholder": "user@example.com",
              "label": "email"
          },
          "autocomplete": {
              "placeholder": "input an 'a'"
          }
      },
      "chip": {
          "title": "Chip {0}",
          "verify": "Verify"
      },
      "forgot_password": {
          "title": "Forgot my password: {0}"
      }
  },
  "menu": {
      "get_set_up": "Get set up",
      "dashboard": "Dashboard",
      "curriculum": "Curriculum",
      "learners": "Learners",
      "plan_payment": "Plan & Payment",
      "account": "Account",
      "organizations": "Organizations",
      "branch": "Branch",
      "internal_payment": "Internal Payment"
  },
  "organizations_team": {
      "invite": "Invite",
      "accepted_learners": "Accepted Learners",
      "total_learners": "Total Learners",
      "start_date": "Start Date",
      "end_date": "End Date",
      "status": "Status",
      "invited_leader_to_team": "Invited Leader to Team",
      "could_not_invited_leader_to_team": "Could't invited Leader to Team"
  },
  "account": {
      "account_detail": "Account Details"
  },
  "student_detail": {
      "no_classes_available": "No classes available",
      "last_eps": "Last EPS",
      "assessment_test": "Assessment test"
  },
  "admin_organization_switcher": {
      "title": "You are viewing at",
      "organization": "Organization"
  },
  "read_aloud": {
      "title": "Read Aloud",
      "read_aloud_name": "Read Aloud Name",
      "create_read_aloud": "Create Read Aloud Content",
      "search_read_aloud": "Search Read Aloud Content name",
      "no_read_aloud_yet": "There is no read aloud content for now",
      "no_read_aloud_desc": "Read Aloud Content are your customized lessons that you can assign to your class.",
      "modals_delete_title": "Deleting selected read aloud will affect your current classes. Continue?",
      "create_read_aloud_title": "Create Read Aloud Content",
      "review_confirm": "Review and Confirm",
      "your_read_aloud": "Your Read Aloud Content",
      "edit_read_aloud": "Edit Read Aloud Content",
      "delete_read_aloud_success": "Delete reading aloud successfully",
      "delete_read_aloud_warning": "Delete reading aloud unsuccessfully",
      "errors": {
          "please_provide_text": "Please provide passage"
      },
      "table": {
          "items": "Items",
          "word_length": "Word length"
      },
      "form": {
          "read_aloud_name": "Title",
          "place_holder": "Type or copy and paste your text here",
          "name_your_read_aloud": "Name your Read Aloud Content",
          "information": "My Team Only: Read Aloud Content can only be viewed by your learners in the team to which you assign the Read Aloud. \nMy Organization: Read Aloud can be viewed by members of your organizations (i.e. admins and other leads). \nPublic: Read Aloud Content can be viewed by any ELSA users.",
          "input_reading_text": "Input reading text",
          "button_generate": "Generate Vocabulary list",
          "words": "words",
          "word_length": "Word length"
      },
      "review": {
          "read_aloud_name": "Title"
      },
      "messages": {
          "your_read_aloud_has_been_created_successfully": "Your Read Aloud Content has been created successfully!",
          "your_read_aloud_has_been_updated_successfully": "Your Read Aloud Content has been updated successfully!",
          "edit_disabled_message": "This reading aloud is included in an active assignment. It can not be edited to avoid affecting your learners' progress."
      },
      "detail": {
          "reading_content": "Reading Content"
      },
      "warm_up": {
          "title": "Vocabulary list",
          "description": "We’ve automatically generated a warm-up study set based on your content."
      },
      "modals": {
          "edit_class": {
              "title_save": "Save Class And Assign License",
              "description": "Are you sure you want to save the Class Detail and License changes?"
          },
          "cancel": {
              "title": "Are you sure you want to leave?",
              "decs": "The changes you’ve made will not be saved.",
              "cancel": "Stay on this page",
              "confirm": "Leave"
          },
          "cancelEdit": {
              "title": "Discard unsaved changes?",
              "cancel": "Continue editing",
              "confirm": "Discard"
          },
          "createSuccess": {
              "message": "New study set has been\nsuccessfully created!",
              "study_set_name_label": "Study set name",
              "count_of_item_label": "Count of items",
              "done": "Done",
              "create_another_study_set": "Create another study set"
          },
          "createAssignmentSuccess": {
              "new_assignments_status": "New assignments status",
              "assign_to_class_successfully": "Assigned to class successfully!",
              "assignment_name": "Assignment name",
              "assigned_to": "Assigned to",
              "due_date": "Due date"
          },
          "delete": {
              "confirm": "Delete",
              "cancel": "Cancel"
          },
          "addAssignment": {
              "add_assignment": "Add Assignment",
              "assignment_details": "Assignment Details",
              "add_warm_up": "Add Warm-Up",
              "add_study_set": "Add Study Set",
              "other_settings": "Other Settings"
          },
          "modal_check": {
              "spell_desc": "Looks like some of your items have errors. Proceed anyway?",
              "limit_desc": "An item can not exceed 300 characters. Please check for extra space or try to rephrase or remove unnecessary characters.",
              "back_to_edit": "Back to edit",
              "proceed": "Proceed"
          }
      },
      "overview": {
          "study_set_name": "Study set name",
          "shareable": "Shareable To",
          "category": "Category",
          "phrases_count": "Number of items",
          "created_by": "Created by",
          "phrases_list_title": "Items",
          "phrases_add_success": "This item was successfully added",
          "phrases_add_fail": "This item was not added to your study set.",
          "phrases_add_changed": "This item was clean-up, the original text is:{original_text}",
          "type": "Type",
          "reading_aloud": "Reading Aloud",
          "words": "Words"
      }
  },
  "branch": {
      "list_branch": {
          "title": "Branch",
          "search_branch": "Search branch",
          "create_branch": "Create branch",
          "name_column": "Branch Name",
          "manager_column": "Branch Manager",
          "creation_column": "Creation Date"
      }
  },
  "internal_payment": {
      "title": "Create Payment internal",
      "select_package": "Select package",
      "select_package_placeholder": "Select a package",
      "select_package_error": "Please select a package",
      "quantity": "Quantity",
      "quantity_error": "Please input a quantity",
      "price": "Price",
      "price_error": "Please input a price",
      "payment_error": "Payment error",
      "payment_success": "Payment successfully",
      "select_product_type": "Select product type",
      "select_product_type_placeholder": "Select a product type"
  },
  "dummy_learner": {
      "enroll_success": "Request enroll learner with login alias success",
      "dummy_label": "Login Alias Email"
  },
  "rename_assignment": {
      "rename_modal_title": "Are you sure with this change ?",
      "rename_entity_modal_desc": "Please note that the name will be updated in your's learner app as well",
      "rename_ass_lib_modal_desc": "You’re about to change an assignment name. Do you want to this change to happen to all assigned classes?",
      "rename_checkbox_label": "Yes, change it in all classes."
  },
  "ai_tutor": {
      "role_play_log": "AI Role-play Logs",
      "report_role_play": {
          "title": "Report a Role-play conversation",
          "sender": "Sender",
          "subject": "Subject Line",
          "describe": "Describe the issue",
          "attachment": "Attachment",
          "success": "Report issue successfully.",
          "warning": "Report issue unsuccessfully."
      },
      "metrics": {
          "pronunciation": "Pronunciation (Median)"
      },
      "title": {
          "assignment_completed": "Assignment Completed",
          "assignment_detail": "Assignment Details",
          "overall_assignment_results": "Overall Assignment Results",
          "lesson_performance": "Lesson Performance",
          "individual_performance": "Individual Performance"
      },
      "label_table_performance": {
          "pronunciation": "Pronunciation",
          "vocabulary": "Vocabulary",
          "grammar": "Grammar",
          "lesson_score": "Lesson Score (Mean)"
      },
      "assignment_history": {
          "objectives_completed": "Objectives Completed"
      },
      "tooltip": {
          "assignment_completed": "This is the date when the assignment was first completed by the learner if they do the assignment many times.",
          "overall_score": "This is the highest overall score earned by the learner on the assignment if they do the assignment multiple times.",
          "pronunciation_score": "This is the highest Pronunciation assessment achieved by the learner if they do the assignment multiple times.",
          "vocabulary_score": "This is the highest Vocabulary assessment achieved by the learner if they do the assignment multiple times.",
          "grammar_score": "This is the highest Grammar assessment achieved by the learner if they do the assignment multiple times.",
          "goals_completed": "This is the highest number of Scenario Goals completed by the learner if they do the assignment multiple times.",
          "hints_used": "This is the average number of times the learner used the Hint feature across all study attempts. A lower number indicates the learner spoke independently without relying on suggestions from ELSA AI.",
          "n_input": "This is the average number of times the user spoke during the conversation across all completed attempts.",
          "attempts": "This is the total number of times the learner tried to do the assignment. It includes both complete and incomplete study attempts.",
          "time_spent": "This is the total amount of time the user spent on the assignment across all attempts."
      },
      "score_range": {
        "advanced": "Advanced",
        "intermediate": "Intermediate",
        "elementary": "Elementary"
    },
      "highest": "HIGHEST",
      "avg": "AVG.",
      "total": "TOTAL",
      "goals_completed": "Goals Completed",
      "hints_used": "Hints Used",
      "n_input": "User Turns",
      "attempts": "Attempts",
      "time_spent": "Time Spent",
      "ent": {
        "filter_by_level":"Filter by Level",
        "scenario_tasks": "Scenario Tasks",
        "scenario_goals": "Scenario Goals",
        "assign_title": "Assign a Role-play",
        "assign_success": "Assigned to class successfully!",
        "team_average": "Team Average"
      }
  },
  "user_not_exist": "If your account exists, you will receive a email with a link to reset your password.",
  "user_is_sso": "Your email is associated with Single Sign-On (SSO). Please use your SSO provider to reset your password or contact your administrator for assistance.",
  "migration": {
        "banner_message": "We have upgraded your experience. Go to the new dashboard now.",
        "banner_button": "Go to {productType}",
    }
};
